// src/components/UI.js
import React, {
    createContext,
    forwardRef,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import styled, { keyframes } from "styled-components";
import { Row, Col } from "./RowCol";
import { Popover, PopoverTrigger, PopoverContent } from "./popover";
import { Button } from "./button";
import {
    FormProvider,
    useFormContext,
    useForm as useReactHookForm,
    Controller,
    useFieldArray,
} from "react-hook-form";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "./select";
import { createRoot } from "react-dom/client";
import {
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
} from "./command";
import {
    Check, ChevronsUpDown, ChevronUp, ChevronDown, Terminal, Pencil, Edit,
    Eye, EyeOff,
    ShieldAlert, Home,
    LockKeyhole, LogIn,
    FileEdit,
} from "lucide-react";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbSeparator,
} from "./breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import { RadioGroup, RadioGroupItem } from "./radio-group";
import { Label } from "./label";
import { Loader2 } from "lucide-react";
import {
    ResponsiveModal,
    ResponsiveModalContent,
    ResponsiveModalDescription,
    ResponsiveModalHeader,
    ResponsiveModalTitle,
} from "./responsive-modal";
import { Calendar } from "./calendar";
import { cn } from "./utils";
import { CalendarIcon, Info as InfoImportLucide } from "lucide-react";
import dayjs from "dayjs";
import isMoment from 'dayjs/plugin/isMoment';
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "./card";
import { useDropzone } from "react-dropzone";
import "@xyflow/react/dist/style.css";
import {
    ReactFlow,
    addEdge,
    ConnectionLineType,
    Panel,
    useNodesState,
    useEdgesState,
} from "@xyflow/react";
import dagre from "dagre";
import "@xyflow/react/dist/style.css";
import { useCallback } from "react";
import { Input } from "./input";
import { useTranslation } from "react-i18next";
import { Badge } from "./badge";
import { Toaster, toast } from "sonner";
import DropdownTreeSelect from "react-dropdown-tree-select";
import "react-dropdown-tree-select/dist/styles.css";
import AsyncSelect from 'react-select/async-creatable';
import CreatableSelect from 'react-select/creatable';
import ReactSelect from 'react-select';
import { CustomSwitchWithMore } from "./custom_switch";
import * as d3 from "d3";
import { Checkbox } from "./checkbox";
import { cloneElement } from "react";
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "./carousel";
import { Avatar, AvatarFallback, AvatarImage } from "./avatar";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./tabs";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "./dropdown-menu";
import { CheckIcon, ChevronDownIcon } from '@radix-ui/react-icons';
import { HexColorPicker, RgbColorPicker } from "react-colorful";
import MultipleSelector from "./multiple-selector";
import UploadImg from "./upload_img";
import UploadAudio from "./upload_audio";
import UploadDocument from "./upload_document";
import { Textarea } from "./textarea";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from './accordion'
import ClassifyStructure from './classify_structure/Main'
import { DateTimePicker, TimePickerInput, TimePicker, TimePickerForForm } from './date_time_picker'
import { AspectRatio } from "./aspect-ratio"
import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from './tooltip'
import Divider from './divider'
// import { DateTimePicker } from './datetime-picker'
import { Skeleton } from './skeleton'
import { PieChart, Pie, Cell, Legend } from 'recharts';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ChartOverview, ColumnChart, BarGraghChart, StackedColumnChart, GroupColumnChart, LineBasicChart, PieBasicChart, DonutChart, RadarBasicChart } from '../charts/views/chart_overview'
import JoditEditor from "jodit-react";
import TabsCard from './tabsCard';
import { set } from "date-fns";
import { ResizablePanelGroup, ResizablePanel, ResizableHandle } from './resizable'
import { useRelativeTime } from "./relative_time_controller";
import TitleUpdater from './title_updater'
import ImageFileId, { invalidateImageFileCache } from "./image";
import ListItem from "./list_item";
import ListItemGroup from "./list_item_group";
import {
    PieChart as PieChartRecharts,
    Pie as PieRecharts,
    Cell as CellRecharts,
    Tooltip as TooltipRecharts,
    ResponsiveContainer as ResponsiveContainerRecharts
} from "recharts";
import PieDonutDiscriptionChart from './base_summary_block_1_1';
import BaseSummaryBlock1 from './base_summary_block_1';
import ComponentCard from './component_card';
import AIGenerateButton from './ai_generate_button';
import BaseCanvasEdit0 from './base_canvas_edit_0';
import BaseCanvasEdit2 from './base_canvas_edit_2';
import BaseCanvasEdit3_1 from './base_canvas_edit_3_1';
import BaseCanvasEdit from './base_canvas_edit';
import ButtonGroup from './button_group';
import ChartStackedCategoryBars from './chart_stacked_category_bars';
import StatsCard from './stats-card';
import ColorLabeledStatList from './color_labeled_stat_list';
import PieDonutChart from './pie_donut_chart';
import BaseChart1 from './base_chart_1';
import BaseChart2 from './base_chart_2';
import BaseChart3 from './base_chart_3';
import BaseChart4 from './base_chart_4';
import PageTitle from './page_title';
import CrmCategoryMenu1_1 from '../crm_base/crm_category_menu_1_1.jsx';
import CrmCategoryMenu1 from '../crm_base/crm_category_menu_1.jsx';
import CrmContainerTitle1_1 from '../crm_base/crm_container_title_1_1.jsx';
import CrmContainerTitle1 from '../crm_base/crm_container_title_1.jsx';
import CrmChart1_1 from '../crm_base/crm_chart_1_1';
import CrmChart1 from '../crm_base/crm_chart_1';
import MediaCard from './media_card';
import BaseFileUpload1 from './base_file_upload_1';
import TreeSelect from './tree_select';
import BaseSelect2 from './base_select_2';
import CrmSelect2_2 from '../crm_base/crm_select_2_2.jsx';
import CrmSelect2 from '../crm_base/crm_select_2.jsx';
import CrmSelect from '../crm_base/crm_select.jsx';
import CrmFileUpload1_1 from '../crm_base/crm_file_upload_1_1.jsx';
import CrmFileUpload1 from '../crm_base/crm_file_upload_1.jsx';
import { X } from "lucide-react";
import { LucideIcon } from "./lucide_icon";
import Name1 from "./name_1";
import Name2 from "./name_2";
import Name3 from "./name_3";
import Name4 from "./name_4";
import { BaseTreeSelector } from "./base_tree_selector";
import Name10 from "./name_10";
import BaseSelectBox from './base_select_box.jsx'
import BaseImgCardView from "./base_img_card_view";
import BaseStatsCardTable from "./base_stats_card_table";
import BaseCalendar from "./base_calender";
import BaseBusinessHoursSetting from "./base_business_hour_setting";
import { transformFormColumns } from "./transformFormColumns";
import { TempDataProvider, useGlobalTempStore } from "./hooks/use_global_temp_store";
import { DynamicDataSelector } from './dynamic-data-selector.jsx'; // --- IGNORE ---
import UploadFile from "./upload_file.jsx";
import FileDownloadButton from "./file_download_button.jsx";
dayjs.extend(isMoment);
export { FileDownloadButton }
export { UploadFile }
export { DynamicDataSelector }
export { transformFormColumns }
export { TempDataProvider, useGlobalTempStore }
export { BaseStatsCardTable }
export { BaseBusinessHoursSetting }
export { BaseCalendar }
export { BaseSelectBox }
export { BaseImgCardView }
export { BaseTreeSelector }
export { Name1 }
export { Name2 }
export { Name3 }
export { Name4 }
export { Name10 }
export { LucideIcon }
export { ImageFileId, invalidateImageFileCache }
export { useRelativeTime }
export { DateTimePicker, TimePickerInput, TimePicker, TimePickerForForm }
export {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "./dropdown-menu";

export { Row, Col } from "./RowCol";
export { Popover, PopoverTrigger, PopoverContent } from "./popover";
export { toast } from "sonner";
export { default as ProTableOt } from "./../utility/componentOt/views/ProtableOt";
export { default as ImportButton } from "./../utility/componentOt/views/ImportButton";
export { useProTableOt } from "./../utility/componentOt/controllers/ProtableOtController";
export { Textarea } from "./textarea";
export { Popconfirm } from "./popconfirm";
export { default as Mainlayout } from "./mainlayout";
export { Label };
export { Calendar }

export { Badge };
export { TabsCard };
export { UploadImg };
export { UploadAudio };
export { UploadDocument };
export { Accordion, AccordionItem, AccordionTrigger, AccordionContent }
export { AspectRatio }
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
export { Divider }
export { ChartOverview, ColumnChart, BarGraghChart, StackedColumnChart, GroupColumnChart, LineBasicChart, PieBasicChart, DonutChart, RadarBasicChart }
export { useCRUDController } from "./classify_structure/CRUDController";
export { ModifyModal } from './../utility/componentOt/controllers/ProtableOtController'
export { ResizablePanelGroup, ResizablePanel, ResizableHandle }
export { toast as toastify, ToastContainer } from 'react-toastify';

export { TitleUpdater }
export { PieDonutDiscriptionChart }
export { BaseSummaryBlock1 }
export { ComponentCard }
export { AIGenerateButton }
export { BaseCanvasEdit0 }
export { BaseCanvasEdit2 }
export { BaseCanvasEdit3_1 }
export { BaseCanvasEdit }
export { ListItem }
export { ListItemGroup }
export { ButtonGroup }
export { ChartStackedCategoryBars }
export { StatsCard }
export { ColorLabeledStatList }
export { PieDonutChart }
export { BaseChart1 }
export { BaseChart2 }
export { BaseChart3 }
export { BaseChart4 }
export { PageTitle }
export { CrmCategoryMenu1_1 }
export { CrmCategoryMenu1 }
export { CrmContainerTitle1_1 }
export { CrmContainerTitle1 }
export { CrmChart1_1 }
export { CrmChart1 }
export { MediaCard }
export { BaseFileUpload1 }
export { TreeSelect }
export { BaseSelect2 }
export { CrmSelect2_2 }
export { CrmSelect2 }
export { CrmSelect }
export { CrmFileUpload1_1 }
export { CrmFileUpload1 }
export { CalendarFilter } from './calendar_filter.jsx'
const StyledCol = styled.div`
    padding-left: ${(props) => props.gutter / 2}px;
    padding-right: ${(props) => props.gutter / 2}px;
    flex: 0 0 ${(props) => (props.span / 24) * 100}%;
    max-width: ${(props) => (props.span / 24) * 100}%;
`;
const DeletePopHover = ({ onConfirm = () => { }, onCancel = () => { } }) => {
    const [deleteOpen, setDeleteOpen] = useState(false);
    return (
        <Popover open={deleteOpen}>
            <PopoverTrigger asChild>
                <Button
                    onClick={() => {
                        setDeleteOpen(true);
                    }}
                    style={{
                        backgroundColor: '#FFCDD2',
                        color: '#D32F2F'
                    }}
                >
                    刪除
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-60" onFocusOutside={() => setDeleteOpen(false)}>
                <Row>
                    <Col span={24}>確定要刪除嗎？</Col>
                    <Col span={24}>
                        <Row justify={"space-around"}>
                            <Col>
                                <Button
                                    variant="outline"
                                    size="sm"
                                    onClick={() => {
                                        setDeleteOpen(false);
                                        onCancel();
                                    }}
                                >
                                    取消
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    size="sm"
                                    onClick={() => {
                                        onConfirm();
                                    }}
                                >
                                    確定
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </PopoverContent>
        </Popover>
    );
};

const setParamsFilter = (obj) => {
    return Object.entries(obj).reduce(
        (all, [key, value]) =>
            value === "" ? { ...all } : { ...all, [key]: value },
        {}
    );
};

const P = ({ children = <></>, mt = 3, leading = 7, style = {}, ...props }) => {
    return (
        <>
            <p
                className={
                    "leading-" + leading + " [&:not(:first-child)]:mt-" + mt
                }
                style={{ ...style }}
                {...props}
            >
                {children}
            </p>
        </>
    );
};
const Title = ({ level = 1, ...props }) => {
    if (level === 2) {
        return (
            <h2
                className="scroll-m-20  pb-2 text-3xl font-semibold tracking-tight first:mt-0"
                {...props}
            ></h2>
        );
    } else if (level === 3) {
        return (
            <h3
                className="scroll-m-20 text-2xl font-semibold tracking-tight"
                {...props}
            ></h3>
        );
    } else if (level === 4) {
        return (
            <h4
                className="scroll-m-20 text-xl font-semibold tracking-tight"
                {...props}
            ></h4>
        );
    } else {
        return (
            <h1
                className="scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl"
                {...props}
            ></h1>
        );
    }
};
const Typography = () => { };
Typography.P = P;
Typography.Title = Title;


const convertUndefined = (value) => {
    if (typeof value === 'object' && value !== null) {
        // If the value is an object or array, recursively handle its properties or elements
        Object.keys(value).forEach((key) => {
            if (value instanceof File) {
            } else {
                value[key] = convertUndefined(value[key]);
            }
        });
    } else if (value === 'undefined') {
        // If the value is the string 'undefined', convert it to actual undefined
        return undefined;
    }
    return value;
}
const CustomForm = ({
    form,
    initialValues,
    onValuesChange = () => { },
    onFinish,
    children,
    labelCol = 8,
    wrapperCol = 16,
    ...rest
}) => {
    const form_ = useReactHookForm();
    const reactHookForm = form || form_;
    const onSubmit = async (data, ...props) => {
        if (onFinish) {
            await onFinish(data);
        }
    };
    const convertUndefined = (value) => {
        if (typeof value === 'object' && value !== null && !(value instanceof File)) {
            // If the value is an object or array, recursively handle its properties or elements
            Object.keys(value).forEach((key) => {
                value[key] = convertUndefined(value[key]);
            });
        } else if (value === 'undefined') {
            // If the value is the string 'undefined', convert it to actual undefined
            return undefined;
        }
        return value;
    }
    useEffect(() => {
        const subscription = reactHookForm.watch((value, { name, type }) => {
            if (type) {
                const values = convertUndefined(value);
                return onValuesChange(values, { name, type })
            }
        });
        return () => subscription.unsubscribe();
    }, [reactHookForm.watch]);

    useEffect(() => {
        if (initialValues) reactHookForm.reset(initialValues);
    }, []);

    reactHookForm.submit = () => {
        reactHookForm.handleSubmit(onSubmit)();
    };

    return (
        <FormProvider {...reactHookForm}>
            <form onSubmit={reactHookForm?.handleSubmit(onSubmit)} {...rest}>
                {children}
            </form>
        </FormProvider>
    );
};
const CustomFormItem = ({
    name,
    label,
    children = <div></div>,
    rules = [],
    hidden = false,
    labelCol = 8,
    labelStyle = {},
    wrapperCol = 16,
    extra,
    labelAlign = "horizontal",
    disabled = false,
}) => {
    const {
        register,
        formState: { errors, isSubmitted },
        control,
    } = useFormContext();
    const filteredName = Array.isArray(name)
        ? name.filter(item => item !== "" && item !== undefined && item !== null)
        : [name];
    const internalName = Array.isArray(filteredName) ? filteredName.join(".") : filteredName;
    const valueCol = label ? wrapperCol : 24
    const nameHasError = !!errors[internalName];
    return (
        <>
            <Controller
                name={internalName}
                control={control}
                rules={rules?.find((_) => true)?.required ? rules?.find((_) => true) : undefined}
                render={({
                    field: { onChange: onFieldChange, value, id },
                    formState: { errors, isSubmitted },
                }) => (
                    <div hidden={hidden}>
                        <Row gutter={[8, 8]} align={"middle"}>

                            {label && (
                                <>
                                    <Col className={labelCol === 24 ? "text-left" : "text-right"} span={labelCol} style={{ ...labelStyle }}>
                                        {rules.find(rule => rule?.required) && <sup style={{ color: 'red' }} >*</sup>}
                                        {labelAlign === "horizontal" ? <label>{label}：</label> : <></>}
                                        {labelAlign === "vertical" ? <label>{label}</label> : <></>}
                                    </Col>
                                </>
                            )}
                            <Col
                                span={
                                    isSubmitted && nameHasError && rules.length !== 0
                                        ? valueCol - 4
                                        : valueCol
                                }
                            >
                                <Row>
                                    <Col span={24}>
                                        {React.cloneElement(children, {
                                            key: id,
                                            name: internalName,
                                            disabled: disabled,
                                            onValueChange: (e) => {
                                                onFieldChange(e);
                                                if (
                                                    children?.props?.hasOwnProperty(
                                                        "onChange"
                                                    )
                                                )
                                                    children?.props?.onChange(e);
                                            },
                                            value: value !== undefined ? value : "",
                                            ...register(internalName),
                                        })}
                                    </Col>

                                </Row>
                            </Col>
                            <Col span={24}>
                                <div style={{
                                    color: "#999899",
                                    fontSize: "12px"
                                }}>
                                    <Row justify={"end"}>
                                        <Col span={valueCol}>
                                            {typeof extra === "string" ? <Typography.P> {extra}</Typography.P> : extra}

                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            {isSubmitted && nameHasError && rules.map(
                                (rule) =>
                                    rule?.required && (
                                        <Col className="text-red-600 italic">
                                            {rule?.message}
                                        </Col>
                                    )
                            )}
                        </Row>
                        {errors[name] && (
                            <span style={{ color: "red" }}>
                                {errors[name].message}
                            </span>
                        )}
                    </div>
                )}
            />
        </>
    );
};
const CustomFormList = ({ label, name, children,
    labelCol = 0,
    wrapperCol = 24, }) => {
    const { control } = useFormContext();
    const filteredName = Array.isArray(name)
        ? name.filter(item => item !== "" && item !== undefined && item !== null)
        : [name];
    const internalName = filteredName.join(".");
    const { fields, append, remove, move } = useFieldArray({
        control,
        name: internalName,
    });
    return (
        <div>
            <Row gutter={[8, 16]} align={"middle"}>
                {label && (
                    <>
                        <Col className="text-right" span={labelCol}>
                            <Typography.Title level={4}>{label}</Typography.Title>
                        </Col>
                    </>
                )}
                <Col
                    span={wrapperCol}
                >
                </Col>
            </Row>
            <Row gutter={[8, 16]} align={"middle"}>
                <Col className="text-right" span={labelCol}>
                </Col>
                <Col
                    span={wrapperCol}
                >
                    {
                        children(
                            fields.map((mapItem, index) => ({
                                ...mapItem,
                                name: [internalName, index].join("."),
                            })),
                            { add: (item = {}) => append(item), remove, move }
                        )
                    }
                </Col>
            </Row>
        </div >
    );
};
const useForm = (options) => {
    const methods = useReactHookForm(options);

    const setFieldsValue = (values, name = undefined) => {
        if (values === null) {
            values = {};
        }
        Object.keys(values).forEach((field) => {
            const fields = name ? [name, field] : [field];
            // 將 null 值轉換為 undefined
            if (values[field] === null) {
                values[field] = undefined;
            }
            methods.setValue(fields.join("."), values[field]);
            if (typeof values[field] === "object")
                setFieldsValue(values[field], fields.join("."));
        });
    };

    const setFieldValue = (name, value) => {
        setFieldsValue({ [name]: value })
    };
    const resetFields = (values) => {
        methods.reset(values);
    };
    const getFieldValue = (values) => {
        const internalName = Array.isArray(values) ? values.join(".") : values;
        return methods.getValues(internalName);
    };
    const getFieldsValue = () => {
        return methods.getValues();
    };
    const validateFields = () => {
        return methods.trigger();
    }
    methods.getFieldValue = getFieldValue;
    methods.getFieldsValue = getFieldsValue;
    methods.setFieldsValue = setFieldsValue;
    methods.setFieldValue = setFieldValue;
    methods.resetFields = resetFields;
    methods.validateFields = validateFields;
    return [methods];
};

const useWatch = (name, form) => {
    const internalName = Array.isArray(name) ? name?.filter(item => item !== undefined).join(".") : name;
    const form_ = useReactHookForm();
    const reactHookForm = form || form_;
    const values = reactHookForm.watch(internalName);
    return convertUndefined(values);
};
const useCustomWatch = (name, form) => {
    const { control } = form;
    return useWatch({
        control,
        name
    })
}
CustomForm.Item = CustomFormItem;
CustomForm.List = CustomFormList;
CustomForm.useForm = useForm;
CustomForm.useWatch = useWatch;
CustomForm.useCustomWatch = useCustomWatch;

export { CustomForm as Form, useFormContext };


const CustomSelect = ({ value = undefined, onValueChange = () => { }, onChange = () => { }, defaultValue, placeholder, options = [], name, defaulDisabled = false, ...props }) => {
    const extendedOptions = [{ label: '請選擇 ...', value: undefined, disabled: defaulDisabled }, ...options];
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    return <>
        <>
            {
                control ?
                    <Controller
                        name={name}
                        control={control}
                        render={
                            ({ field, fieldState: { error } }) => (
                                <Select
                                    name={field.name}
                                    onValueChange={
                                        (e) => {
                                            onValueChange(e);
                                            field.onChange({
                                                target: {
                                                    name,
                                                    value: e
                                                }
                                            })
                                            onChange({
                                                target: {
                                                    name,
                                                    value: e
                                                }
                                            })
                                        }
                                    } value={value !== undefined ? `${value}` : ''}
                                >
                                    <SelectTrigger>
                                        <SelectValue placeholder={value !== undefined ? undefined : placeholder || "請選擇 ..."} />
                                    </SelectTrigger>
                                    <SelectContent>
                                        {
                                            extendedOptions.map(mapItem => <>
                                                <SelectItem {...mapItem} value={`${mapItem?.value}`}> {mapItem?.label || mapItem?.value}</SelectItem>
                                            </>)}
                                    </SelectContent>
                                </Select>
                            )}
                    />
                    :
                    <Select
                        name={name}
                        onValueChange={(e) => {
                            onValueChange(e);
                            onChange(e)
                        }} value={value !== undefined ? `${value}` : undefined}
                    >
                        <SelectTrigger>
                            <SelectValue placeholder={value !== undefined ? undefined : placeholder || "請選擇 ..."} />
                        </SelectTrigger>
                        <SelectContent>
                            {
                                extendedOptions.map(mapItem => <>
                                    <SelectItem {...mapItem} value={`${mapItem?.value}`}> {mapItem?.label || mapItem?.value}</SelectItem>
                                </>)}
                        </SelectContent>
                    </Select>
            }
        </>
    </>
}

const CustomAsyncSelect = ({
    request
    // = async () => {
    //     return await new Promise(
    //         (resolve, reject) => {
    //             resolve()
    //         }
    //     )
    //         .then(() => {
    //             return {
    //                 data: Array(1000).fill(0).map((item, index) => ({ label: index, value: index })),
    //                 total: 0
    //             }
    //         })
    // }
    ,
    defaultValue,
    placeholder = '請選擇 ...',
    defaulDisabled = false,
    value = undefined,
    name = undefined,
    onChange = () => { },
    onSelect = () => { },
    onValueChange = () => { },
    options,
    mode: mode_,
    allowClear = false,
    disabled = false,
    onlyValue = true,
    onlyValueAll = false,
    menuPortalTarget,
    ...props
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [internalOptions, setInternalOptions] = useState([])
    const externalOptions = options || internalOptions

    const loadMoreOptions = async (...args) => {
        if (request) {
            setIsLoading(true);
            const result = await request()
            setInternalOptions(result)
            setIsLoading(false);
            return result?.data;
        }
        return options
    };
    const mode = ['multiple', 'tags'].includes(mode_) ? 'multiple' : undefined
    const ReactSelect_ = mode_ === "tags" ? CreatableSelect : ReactSelect
    const resolvedMenuPortalTarget = menuPortalTarget === undefined
        ? (typeof document !== "undefined" ? document.body : null)
        : menuPortalTarget
    return <>
        {request && <>
            <AsyncSelect
                cacheOptions
                defaultOptions
                loadOptions={loadMoreOptions}
                onMenuScrollToBottom={loadMoreOptions}
                isLoading={isLoading}
                isDisabled={disabled}
                {...(value ? {
                    value: Array.isArray(value) ?
                        externalOptions.filter(item => value.includes(item.value))?.map(item => item)
                        :
                        externalOptions.find(item => String(item.value) === String(value))
                } : {}
                )}
                {...(onlyValue ? {} : { value: value })}
                onChange={(e) => {
                    let values = e
                    if (mode === "multiple") {
                        if (onlyValue) {
                            values = e?.map(item => item.value)
                        } else {
                            values = e
                        }
                    }
                    if (name) {
                        onChange({
                            target: {
                                name,
                                value: values
                            }
                        })
                        onValueChange({
                            target: {
                                name,
                                value: values
                            }
                        })
                    } else {
                        onChange(values)
                        onValueChange(values)
                    }
                }}
            />
        </>}
        {!request && <>
            <ReactSelect
                menuPortalTarget={resolvedMenuPortalTarget}
                menuPosition={resolvedMenuPortalTarget ? "fixed" : "absolute"}
                captureMenuScroll={false}       // 防止它強行攔截滾動事件
                closeMenuOnScroll={false}      // 防止捲動頁面時選單自動關閉
                menuShouldScrollIntoView={true} // 確保選單開啟時會對齊
                placeholder={placeholder}
                defaultValue={defaultValue}
                isClearable={allowClear}
                isDisabled={disabled}
                onMenuOpen={resolvedMenuPortalTarget ? () => {
                    // 當選單開啟時，暫時允許 body 接收所有事件
                    document.body.style.pointerEvents = 'auto';
                } : undefined}
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                        pointerEvents: 'auto' // 強制開啟指標事件
                    }),
                    menu: (provided) => ({
                        ...provided,
                        width: 'auto', // Allows the width to be determined by the content
                        minWidth: '100%', // Ensures that the dropdown is at least as wide as the select input
                        zIndex: 9999
                    }),
                    menuList: (provided) => ({
                        ...provided,
                        width: 'auto', // Adjusts the list width according to content
                        WebkitOverflowScrolling: 'touch', // 確保行動裝置滑動順暢
                        maxHeight: '200px',    // 強制縮小高度，讓捲軸必須出現
                        overflowY: 'auto',     // 確保垂直捲軸開啟
                        display: 'block',      // 確保它是區塊元素
                        paddingRight: '4px',   // 預留捲軸寬度，防止內容遮擋
                        scrollbarWidth: 'thin',
                    }),
                    container: (provided) => ({
                        ...provided,
                        width: 'auto', // Optional: Adjust the container width if needed
                    }),
                }}
                {...(value ? {
                    value: Array.isArray(value) ?
                        externalOptions.filter(item => value.includes(item.value))
                        // ?.map(item => item.value)
                        :
                        externalOptions.find(item => String(item.value) === String(value))
                } : {}
                )}
                {...(onlyValue ? {} : { value: value })}
                isMulti={mode === "multiple"}
                closeMenuOnSelect={mode !== "multiple"}
                options={externalOptions}
                onChange={(e) => {
                    let values = e?.value
                    if (mode === "multiple") {
                        if (onlyValue) {
                            values = e?.map(item => item.value)
                        } else {
                            values = e
                        }
                    }
                    if (name) {
                        onChange({
                            target: {
                                name,
                                value: values === undefined ? null : values
                            }
                        })
                        onValueChange({
                            target: {
                                name,
                                value: values === undefined ? null : values
                            }
                        })
                        onSelect(values)
                    } else {
                        onChange(values)
                        onValueChange(values)
                        onSelect(values)
                    }
                }}
            />
        </>}
    </>
};

const CustomMultipleSelect = ({ value = undefined, onValueChange = () => { }, onChange = () => { }, defaultValue, placeholder, options = [], name, defaulDisabled = false, ...props }) => {
    const extendedOptions = [{ label: '請選擇 ...', value: undefined, disabled: defaulDisabled }, ...options];
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    const label_string = Array.isArray(value) && value.length > 0 ?
        value?.map((mapItem) => (
            extendedOptions.find((option) => `${option?.value}` == `${mapItem}`)?.label || ''
        )).join(',') :
        ''

    const renderSelectComponent = (field = null, name) => (
        <Select
            onValueChange={(selectedValue) => {
                const newSelectedValues = value.includes(selectedValue)
                    ? value.filter(v => v !== selectedValue)
                    : [...value, selectedValue];
                onValueChange(newSelectedValues);
                field.onChange({
                    target: {
                        name,
                        value: newSelectedValues
                    }
                })
                onChange({
                    target: {
                        name,
                        value: newSelectedValues
                    }
                })
            }}
        >
            <SelectTrigger>
                <SelectValue placeholder={label_string != '' ? label_string : placeholder}>
                    {label_string != '' ? label_string : ''}
                </SelectValue>
            </SelectTrigger>
            <SelectContent>
                {
                    extendedOptions.map(mapItem => (
                        <SelectItem
                            {...mapItem}
                            value={`${mapItem?.value}`}
                        >
                            <Row>
                                {mapItem?.label || mapItem?.value}
                                {
                                    value && value.includes(`${mapItem?.value}`) && (
                                        <CheckIcon className="ml-2 text-green-500" />
                                    )
                                }
                            </Row>
                        </SelectItem>
                    ))}
            </SelectContent>
        </Select >
    );
    return <>
        <>
            {
                control ?
                    <Controller
                        name={name}
                        control={control}
                        render={({ field, fieldState: { error } }) => renderSelectComponent(field, name)}
                    />
                    :
                    renderSelectComponent()
            }
        </>
    </>
}

export { SelectContent, SelectItem, SelectTrigger, SelectValue, }
CustomAsyncSelect.MultipleSelect = CustomMultipleSelect
export { CustomAsyncSelect as Select };

const CustomSelectCombo = ({
    name,
    rules,
    onValueChange,
    defaultValue,
    placeholder,
    options = [],
    ...props
}) => {
    const { control } = useFormContext();
    return (
        <>
            <Controller
                name={name}
                control={control}
                rules={rules}
                render={({
                    field: { onChange, value },
                    fieldState: { error },
                }) => (
                    <DropdownMenu>
                        <DropdownMenuTrigger asChild>
                            <Button
                                variant="outline"
                                role="combobox"
                                className={
                                    // cn(
                                    "w-[200px] justify-between"
                                    // !field.value && "text-muted-foreground"
                                    // )
                                }
                            >
                                {value
                                    ? options.find(
                                        (option) => option.value === value
                                    )?.label
                                    : "Select option"}
                                <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                            </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent className="w-[200px] p-0">
                            <Command>
                                <CommandInput placeholder="Search option..." />
                                <CommandEmpty>No option found.</CommandEmpty>
                                <CommandGroup>
                                    {options.map((option) => (
                                        <CommandItem
                                            value={option.label}
                                            key={option.value}
                                            onSelect={() => {
                                                onChange(option.value);
                                            }}
                                        >
                                            <Check className={"opacity-0"} />
                                            {option.label}
                                        </CommandItem>
                                    ))}
                                </CommandGroup>
                            </Command>
                        </DropdownMenuContent>
                    </DropdownMenu>
                )}
            />
        </>
    );
};
export { CustomSelectCombo as SelectCombo };

const CustomButton = ({
    type = "primary", // 按鈕類型
    loading = false, // 是否顯示 loading 狀態
    size = "medium", // 按鈕大小
    htmlType = "button", // HTML 按鈕類型
    block = false, // 是否全寬
    selected = false, // 是否處於選中狀態
    icon, // 按鈕旁的icon
    iconPosition = "left",
    ...props // 其餘 props
}) => {
    const sizeStyles = {
        small: "sm",
        medium: "default",
        large: "lg",
        icon: "icon",
    };
    const sizeStyle = sizeStyles[size] || sizeStyles.medium;

    const typeMapping = {
        text: "link",
        link: "link",
        danger: "destructive",
        default: "outline",
        ghost: "ghost"
    };

    const variant = typeMapping[type];

    const selectedStyle = selected
        ? {
            border: "2px solid #5c9ded", // 調整為柔和藍色
            backgroundColor: "#edf5ff", // 輕微淺藍背景
            color: "#2b65d3", // 藍色文字，和諧且不突兀
            fontWeight: "bold", // 突出文字
        }
        : {};

    return (
        <>
            {!loading && (
                <Button
                    type={htmlType}
                    variant={variant}
                    size={sizeStyle}
                    style={{
                        ...props.style,
                        ...selectedStyle, // 添加選中樣式
                        width: block ? "100%" : "auto",
                    }}
                    {...props}
                >
                    {icon && iconPosition === "left" && (
                        <span className="mr-2">{icon}</span>
                    )}
                    {props.children}
                    {icon && iconPosition === "right" && (
                        <span className="ml-2">{icon}</span>
                    )}
                </Button>
            )}
            {loading && (
                <Button
                    disabled
                    type={htmlType}
                    variant={variant}
                    size={sizeStyle}
                    style={{
                        ...props.style,
                        ...selectedStyle, // 添加選中樣式
                        width: block ? "100%" : "auto",
                    }}
                    {...props}
                >
                    <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                    {props?.children}
                </Button>
            )}
        </>
    );
};
const CustomButtonRadioGroup = ({
    options = [],
    name,
    value,
    onChange,
    onValueChange,
    buttonType = "primary", // 默認按鈕類型
    buttonSize = "medium", // 默認按鈕大小
}) => {
    const [selectedValue, setSelectedValue] = useState(value);

    const handleClick = (optionValue) => {
        setSelectedValue(optionValue);

        // 模擬原生事件結構，讓父層更好處理
        const event = {
            target: {
                name,
                value: optionValue,
            },
        };

        if (onChange) {
            onChange(event);
        }

        if (onValueChange) {
            onValueChange(optionValue);
        }
    };

    return (
        <div style={{ display: "flex", gap: "8px" }}>
            {options.map((option, index) => (
                <CustomButton
                    key={index}
                    type={buttonType}
                    size={buttonSize}
                    selected={selectedValue === option.value} // 使用選中樣式
                    onClick={() => handleClick(option.value)}
                >
                    {option.label}
                </CustomButton>
            ))}
        </div>
    );
};
CustomButton.RadioGroup = CustomButtonRadioGroup


export { CustomButton as Button };

const CustomBreadCrumb = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);
    const { t } = useTranslation();
    return (
        <Breadcrumb>
            <BreadcrumbList>
                <BreadcrumbItem>
                    <BreadcrumbLink onClick={() => navigate("/")}>
                        <HomeOutlined />
                    </BreadcrumbLink>
                </BreadcrumbItem>
                {pathnames.map((value, index) => {
                    const to = `/${pathnames
                        .slice(0, index + 1)
                        .join("/")}`;
                    return (
                        <React.Fragment key={to}>
                            <BreadcrumbSeparator />
                            <BreadcrumbItem>
                                <BreadcrumbLink
                                    onClick={() => navigate(to)}
                                >
                                    {t(
                                        pathnames
                                            .slice(0, index + 1)
                                            .join(".") + "."
                                    ) !==
                                        pathnames
                                            .slice(0, index + 1)
                                            .join(".") &&
                                        t(
                                            pathnames
                                                .slice(0, index + 1)
                                                .join(".") + "."
                                        )}
                                    {t(
                                        pathnames
                                            .slice(0, index + 1)
                                            .join(".") + "."
                                    ) ===
                                        pathnames
                                            .slice(0, index + 1)
                                            .join(".") &&
                                        value.charAt(0).toUpperCase() +
                                        value.slice(1)}
                                </BreadcrumbLink>
                            </BreadcrumbItem>
                        </React.Fragment>
                    );
                })}
            </BreadcrumbList>
        </Breadcrumb>
    );
};
export { CustomBreadCrumb as BreadCrumb };

// ✅ 單個選項樣式 (卡片式)
const RadioCard = styled(Label)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f8f9fa;
  transition: background 0.2s;
  cursor: pointer;
  border: 2px solid transparent;

  &:hover {
    background: #eaeff5;
  }

  &[data-state="checked"] {
    border-color: #3b82f6;
    background: #eaf3ff;
  }
`;

// 🔘 自訂 Radio 按鈕
const StyledRadio = styled(RadioGroupItem)`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #bbb;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;

  &[data-state="checked"] {
    border-color: #3b82f6;
  }
`;

const CustomRadio = ({ children, value, types, ...props }) => {
    return (
        <>
            {types === undefined && <Label style={{}}>
                <Label className="flex items-center space-x-2 cursor-pointer">
                    <RadioGroupItem {...props} value={value} />
                    {children}
                </Label>
            </Label>}
            {types === "netlify" && <>
                <RadioCard className="flex items-center space-x-2 cursor-pointer">
                    <StyledRadio {...props} value={value} />
                    {children}
                </RadioCard>
            </>}
        </>
    );
};

const CustomRadioGroup = ({
    name,
    value = undefined,
    onValueChange = () => { },
    onChange = () => { },
    defaultValue,
    placeholder,
    children,
    // layout direction: 'vertical' (default) or 'horizontal'
    direction = 'vertical',
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    return (
        <>
            <RadioGroup
                // pass className according to direction; RadioGroup defaults to vertical grid
                className={direction === 'horizontal' ? 'flex items-center gap-2' : 'grid gap-2'}
                onValueChange={(e) => {
                    if (control) {
                        onValueChange({
                            target: {
                                name,
                                value: e,
                            },
                        });
                        onChange({
                            target: {
                                name,
                                value: e,
                            },
                        });
                    } else {
                        onValueChange(e);
                        onChange(e);
                    }
                }}
                className={props.className !== undefined ? props.className : "flex flex-row"}
                value={value !== undefined ? value : ""}
                {...props}
            >
                {children}
            </RadioGroup>
        </>
    );
};
CustomRadio.Group = CustomRadioGroup;
export { CustomRadio as Radio };

const CustomModal = ({
    title,
    children,
    open,
    footer,
    onCancel,
    onOk,
    onClose,
    okText = "OK",
    okProps = {},
    cancelText = "Cancel",
    closeText = "Close",
    modalRender,
    close = false,
    contentStyle = { padding: 0 },
    width,
    confirmLoading = false,
    maxHeight,
    minHeight,
    fullHeightOnMobile = true,
    ...props
}) => {
    const [isMobile, setIsMobile] = useState(
        typeof window !== "undefined" ? window.innerWidth < 768 : false
    );

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    const outerMaxHeight = isMobile ? "100dvh" : "95dvh";
    const resolvedMinHeight = minHeight ?? (isMobile ? "auto" : "20vh");

    const modalContent = modalRender ? (
        modalRender({
            title, children, footer, onCancel, onOk, okText, okProps, cancelText,
        })
    ) : (
        <Row
            gutter={[8, 8]}
            justify={"center"}
            align={"middle"}
            style={{
                flex: 1,
                minHeight: 0,            // ← 關鍵:讓內部 Col 能正確縮小
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",      // ← 避免 Row 預設 wrap 破壞直向佈局
                width: "100%",
                margin: 0,
            }}
        >
            {/* Header - 固定 */}
            <Col span={24} style={{ flexShrink: 0 }}>
                <ResponsiveModalHeader>
                    <ResponsiveModalTitle>{title}</ResponsiveModalTitle>
                </ResponsiveModalHeader>
            </Col>

            {/* Body - 吃剩餘空間並捲動 */}
            <Col
                span={24}
                style={{
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <ResponsiveModalDescription
                    style={{
                        flex: 1,
                        minHeight: resolvedMinHeight,
                        overflowX: "auto",
                        overflowY: "auto",
                        WebkitOverflowScrolling: "touch",
                        ...contentStyle,
                    }}
                >
                    {children}
                </ResponsiveModalDescription>
            </Col>

            {/* Footer - 固定在底部 */}
            <Col
                span={24}
                style={{
                    flexShrink: 0,
                    paddingTop: 8,
                    borderTop: "1px solid #f0f0f0",
                }}
            >
                <Row gutter={[8, 8]} justify={"center"} align={"middle"}>
                    {footer ? (
                        footer
                    ) : (
                        <>
                            <Col>
                                {onOk && (
                                    <CustomButton onClick={onOk} loading={confirmLoading} {...okProps}>
                                        {okText}
                                    </CustomButton>
                                )}
                            </Col>
                            <Col>
                                {onCancel && (
                                    <CustomButton onClick={onCancel} loading={confirmLoading} variant="outline">
                                        {cancelText}
                                    </CustomButton>
                                )}
                            </Col>
                            <Col>
                                {close && (
                                    <CustomButton onClick={onClose} loading={confirmLoading} variant="secondary">
                                        {closeText}
                                    </CustomButton>
                                )}
                            </Col>
                        </>
                    )}
                </Row>
            </Col>
        </Row>
    );

    const resolvedWidth = width
        ? (isMobile
            ? "100vw"
            : `min(${typeof width === "number" ? `${width}px` : width}, 100vw)`)
        : undefined;

    return (
        <ResponsiveModal open={open} {...props}>
            <ResponsiveModalContent
                style={{
                    ...(resolvedWidth ? { width: resolvedWidth, maxWidth: "100vw" } : {}),
                    maxHeight: outerMaxHeight,
                    height: isMobile ? "100dvh" : "auto",
                    overflow: "hidden",
                    backgroundColor: "#fffaf0",
                    display: "flex",
                    flexDirection: "column",
                }}
                close={close}
            >
                {modalContent}
            </ResponsiveModalContent>
        </ResponsiveModal>
    );
};
const info = ({
    title,
    footer,
    content,
    onOk,
    onCancel,
    okText = 'OK',
    cancelText = 'Cancel',
    ...props
}) => {
    const container = document.createElement('div');
    document.body.appendChild(container);
    const root = createRoot(container)

    const handleOk = () => {
        if (onOk) onOk();
        closeModal();
    };
    const closeModal = () => {
        root.unmount()
        document.body.removeChild(container);
    };

    root.render(
        <CustomModal
            open={true}
            title={title}
            onOk={handleOk}
            okText={okText}
            contentStyle={{ padding: 8 }}
            {...props}
        >
            {content}
        </CustomModal>
    );
};

const confirm = ({
    title,
    content,
    onOk,
    onCancel,
    onClose,
    okText = "OK",
    cancelText = "Cancel",
    ...props
}) => {
    const container = document.createElement("div");
    document.body.appendChild(container);
    const root = createRoot(container);
    const handleOk = () => {
        if (onOk) onOk();
        closeModal();
    };

    const handleCancel = () => {
        if (onCancel) onCancel();
        closeModal();
    };
    const handleClose = () => {
        if (onClose) onClose();
        closeModal();
    };

    const closeModal = () => {
        root.unmount();
        document.body.removeChild(container);
    };

    root.render(
        <CustomModal
            open={true}
            title={title}
            onOk={handleOk}
            onCancel={handleCancel}
            onClose={handleClose}
            okText={okText}
            cancelText={cancelText}
            contentStyle={{ padding: 8 }}
            {...props}
        >
            {content}
        </CustomModal>
    );
};
CustomModal.confirm = confirm;
CustomModal.info = info
export { CustomModal as Modal };

const Alert = styled.div`
    & .alert {
        padding: 15px;
        margin-bottom: 20px;
        border: 1px solid transparent;
        border-radius: 4px;
        display: flex;
        align-items: center;
    }

    & .alert-success {
        color: #3c763d;
        background-color: #dff0d8;
        border-color: #d6e9c6;
    }

    & .alert-info {
        color: #31708f;
        background-color: #d9edf7;
        border-color: #bce8f1;
    }

    & .alert-warning {
        color: #8a6d3b;
        background-color: #fcf8e3;
        border-color: #faebcc;
    }

    & .alert-danger {
        color: #a94442;
        background-color: #f2dede;
        border-color: #ebccd1;
    }

    & .alert-icon {
        margin-right: 10px;
    }

    & .alert-content {
        display: flex;
        flex-direction: column;
    }

    & .alert-message {
        font-weight: bold;
    }

    & .alert-description {
        margin-top: 5px;
    }
`;
const CustomAlert = ({ type, message, description, icon, showIcon }) => {
    const renderIcon = () => {
        if (icon) {
            return React.cloneElement(icon, { className: "h-4 w-4" });
        }
        // Default to Terminal icon if no icon is provided
        return <Terminal className="h-4 w-4" />;
    };

    const alertType = () => {
        switch (type) {
            case "success":
                return "alert-success";
            case "info":
                return "alert-info";
            case "warning":
                return "alert-warning";
            case "error":
                return "alert-danger";
            default:
                return "alert-info";
        }
    };

    return (
        <Alert>
            <div
                className={`alert ${alertType()} ${showIcon ? "show-icon" : ""
                    }`}
                role="alert"
            >
                {showIcon && <span className="alert-icon">{renderIcon()}</span>}
                <div className="alert-content">
                    {message && <div className="alert-message">{message}</div>}
                    {description && (
                        <div className="alert-description">{description}</div>
                    )}
                </div>
            </div>
        </Alert>
    );
};
export { CustomAlert as Alert };

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const OverlayWrapper = styled.div`
    position: relative;
`;

const LoaderWrapper = styled.div`
    display: flex;
    flex-direction: column; /* icon 在上，文字在下 */
    align-items: center;
    justify-content: center;
    background-color: ${({ hasChildren }) =>
        hasChildren ? "rgba(0, 0, 0, 0.5)" : "transparent"};
    position: ${({ hasChildren }) =>
        hasChildren ? "absolute" : "static"};
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: ${({ hasChildren, size }) =>
        !hasChildren ? `${size}px` : "auto"};
    height: ${({ hasChildren, size }) =>
        !hasChildren ? `${size}px` : "auto"};
    z-index: 10;
    color: white;

    svg {
        animation: ${spin} 1s linear infinite;
        width: ${({ size }) => (size ? `${size}px` : "24px")};
        height: ${({ size }) => (size ? `${size}px` : "24px")};
        margin-bottom: 8px;
    }

    .loading-text {
        font-size: ${({ size }) => (size ? `${size}px` : "24px")};
        font-weight: 500;
        line-height: 1.2;
    }
`;

const Spin = ({ size = 24, spinning = true, tip = "載入中...", children }) => {
    const hasChildren = React.Children.count(children) > 0;
    return (
        <OverlayWrapper>
            {spinning && (
                <LoaderWrapper size={size} hasChildren={hasChildren}>
                    <Loader2 />
                    {tip && <div className="loading-text">{tip}</div>}
                </LoaderWrapper>
            )}
            {hasChildren && children}
        </OverlayWrapper>
    );
};


export { Spin };
export { DeletePopHover, setParamsFilter, Typography };

const CustomDatePicker = ({
    name = "",
    value = undefined,
    onValueChange = () => { },
    onChange = () => { },
    defaultValue,
    placeholder,
    options,
    format = "YYYY-MM-DD",
    timeZone = "Asia/Taipei",  // 設定預設時區
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;

    const [open, setOpen] = useState(false);
    const popoverRef = useRef(null);

    const handleFocusOut = (event) => {
        if (
            popoverRef.current &&
            !popoverRef.current.contains(event.relatedTarget)
        ) {
            setOpen(false);
        }
    };

    // // 使用 formatDateToTimeZone 函數來格式化日期
    // const formatDateToTimeZone = (date, locale = 'en-US', timeZone = timeZone) => {
    //     return new Intl.DateTimeFormat(locale, {
    //         timeZone,
    //         year: 'numeric',
    //         month: '2-digit',
    //         day: '2-digit',
    //     }).format(date);
    // };

    useEffect(() => {
        const currentPopoverRef = popoverRef.current;
        if (currentPopoverRef) {
            currentPopoverRef.addEventListener("focusout", handleFocusOut);
        }

        return () => {
            if (currentPopoverRef) {
                currentPopoverRef.removeEventListener(
                    "focusout",
                    handleFocusOut
                );
            }
        };
    }, []);
    return (
        <>
            <DropdownMenu open={open} ref={popoverRef}>
                <DropdownMenuTrigger asChild>
                    <Button
                        variant={"outline"}
                        className={cn(
                            "w-[240px] pl-3 text-left font-normal",
                            !value && "text-muted-foreground"
                        )}
                        onClick={() => setOpen(true)}
                    >
                        {value ? (
                            formatDateToTimeZone(new Date(value), undefined, timeZone)
                        ) : (
                            <span>Pick a date</span>
                        )}
                        <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-auto p-0" align="start">
                    {control ? (
                        <Controller
                            name={name}
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <Calendar
                                    mode="single"
                                    selected={dayjs(value).format(format)}
                                    onSelect={(date, ...e) => {
                                        const selectedDate = formatDateToTimeZone(date, undefined, timeZone);
                                        onValueChange({
                                            target: {
                                                name,
                                                value: selectedDate,
                                            },
                                        });
                                        onChange({
                                            target: {
                                                name,
                                                value: selectedDate,
                                            },
                                        });
                                        setOpen(false);
                                    }}
                                    initialFocus
                                />
                            )}
                        />
                    ) : (
                        <Calendar
                            mode="single"
                            selected={value}
                            onSelect={(date, ...e) => {
                                const selectedDate = formatDateToTimeZone(date, undefined, timeZone);
                                onChange(
                                    date,
                                    selectedDate,
                                    ...e
                                );
                                onValueChange(
                                    date,
                                    selectedDate,
                                    ...e
                                );
                                setOpen(false);
                            }}
                            initialFocus
                        />
                    )}
                </DropdownMenuContent>
            </DropdownMenu>
        </>
    );
};

const formatDateToTimeZone = (date, locale = 'en-US', timeZone = "Asia/Taipei") => {
    return new Intl.DateTimeFormat(locale, {
        timeZone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(date);
};
export { formatDateToTimeZone }
const CustomDateTimePicker = ({
    name = "",
    value = undefined,
    onValueChange = () => { },
    onChange = () => { },
    defaultValue,
    placeholder,
    options,
    format = "YYYY-MM-DD HH:mm:ss",
    disabled,
    granularity = "second",
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;

    const [open, setOpen] = useState(false);
    const popoverRef = useRef(null);

    const handleFocusOut = (event) => {
        if (
            popoverRef.current &&
            !popoverRef.current.contains(event.relatedTarget)
        ) {
            setOpen(false);
        }
    };

    // 資料轉換 function: 將輸入轉換為 Day.js 格式
    const toDayjs = (date) => {
        if (!date) return dayjs(); // 如果 date 為空，返回當前時間的 Day.js 對象

        if (typeof date === 'string') {
            // 如果是字串格式，直接使用指定的格式進行解析
            return dayjs(date, format);
        } else if (date instanceof Date) {
            // 如果是 JavaScript Date 對象，直接轉換為 Day.js
            return dayjs(date);
        } else if (dayjs.isMoment(date)) {
            // 如果是 Moment 對象，將其轉換為 Day.js
            return dayjs(date.toDate());
        } else if (dayjs.isDayjs(date)) {
            // 如果已經是 Day.js 對象，直接返回
            return date;
        } else {
            return dayjs(); // 如果資料格式不受支持，返回當前時間
        }
    };

    const dayjsValue = value ? toDayjs(value) : undefined;
    useEffect(() => {
        const currentPopoverRef = popoverRef.current;
        if (currentPopoverRef) {
            currentPopoverRef.addEventListener("focusout", handleFocusOut);
        }

        return () => {
            if (currentPopoverRef) {
                currentPopoverRef.removeEventListener(
                    "focusout",
                    handleFocusOut
                );
            }
        };
    }, []);
    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <DateTimePicker
                            // yearRange
                            hourCycle={24}
                            placeholder={placeholder || format}
                            disabled={disabled}
                            granularity={granularity}
                            value={dayjsValue ? dayjsValue.toDate() : undefined}
                            onChange={(date) => {
                                const formattedDate = dayjs(date).format(format);
                                onValueChange({
                                    target: {
                                        name,
                                        value: formattedDate
                                    },
                                });
                                onChange({
                                    target: {
                                        name,
                                        value: formattedDate
                                    },
                                });
                            }}
                        />
                    )}
                />
            ) : (
                <DateTimePicker
                    // yearRange
                    value={dayjsValue ? dayjsValue.toDate() : undefined}
                    hourCycle={24}
                    placeholder={placeholder || format}
                    disabled={disabled}
                    granularity={granularity}
                    onChange={(date) => {
                        const formattedDate = dayjs(date).format(format);
                        onValueChange({
                            target: {
                                name,
                                value: formattedDate
                            },
                        });
                        onChange({
                            target: {
                                name,
                                value: formattedDate
                            },
                            date: formattedDate,
                            dateString: formattedDate,
                        });
                    }}
                />
            )}

        </>
    );
}

CustomDatePicker.Time = CustomDateTimePicker
export { CustomDatePicker as DatePicker };
const CustomDateRangePicker = ({
    placeholder = ["開始日期", "結束日期"],
    name = "",
    value,
    defaultValue,
    onValueChange = () => { },
    onChange = () => { },
    format = "YYYY-MM-DD HH:mm:ss",
    disabled,
    ...props
}) => {

    const [search, setSearch] = useState({
        time_start: value?.[0] ?? defaultValue?.[0],
        time_end: value?.[1] ?? defaultValue?.[1],
    })
    useEffect(() => {
        if (!!search?.time_start && !!search?.time_end) {
            onValueChange({
                target: {
                    name,
                    value: [search?.time_start, search?.time_end],
                },
            });
            onChange({
                target: {
                    name,
                    value: [search?.time_start, search?.time_end],
                },
            });
        }
        else {
            onValueChange({
                target: {
                    name,
                    value: [],
                },
            });
            onChange({
                target: {
                    name,
                    value: [],
                },

            });
        }
    }, [search])
    return (
        <Row gutter={[4, 4]} align={"middle"}>
            <Col>
                <CustomDateTimePicker
                    placeholder={placeholder[0]}
                    format={format}
                    value={search?.time_start ? dayjs(search?.time_start) : (value ? value?.find(_ => true)?.[0] ?? undefined : undefined)}
                    onChange={(e) => {
                        setSearch((pre) => {
                            let valid_value = "";
                            if (typeof e.target.value === "string") {
                                valid_value = dayjs(e.target.value);
                            } else {
                                valid_value = e.target.value;
                            }
                            if ((valid_value).isBefore(pre?.time_end)) {
                                return {
                                    ...pre,
                                    time_start: dayjs(e.target.value).format(format),
                                }
                            }
                            else {
                                return {
                                    ...pre,
                                    time_start: dayjs(pre?.time_end).format(format),
                                    time_end: dayjs(e.target.value).format(format),
                                }
                            }
                        })
                    }}
                />
            </Col>
            <Col>
                <Typography.Title level={4}>
                    ~
                </Typography.Title>
            </Col>
            <Col>
                <CustomDateTimePicker
                    placeholder={placeholder[1]}
                    format={format}
                    value={search?.time_end ? dayjs(search?.time_end) : (value ? value?.find(_ => true)?.[1] ?? undefined : undefined)}
                    onChange={(e) => {
                        setSearch((pre) => {
                            let valid_value = "";
                            if (typeof e.target.value === "string") {
                                valid_value = dayjs(e.target.value);
                            } else {
                                valid_value = e.target.value;
                            }
                            if ((valid_value).isBefore(pre?.time_start)) {
                                return {
                                    ...pre,
                                    time_start: dayjs(e.target.value).format(format),
                                    time_end: dayjs(pre?.time_start).format(format),
                                }
                            }
                            else {
                                return {
                                    ...pre,
                                    time_end: dayjs(e.target.value).format(format),
                                }
                            }

                        })
                    }}
                />
            </Col>
            <Col>
                <CustomButton
                    type={"icon"}
                    onClick={() => {
                        setSearch((pre) => {
                            return {
                                time_start: undefined,
                                time_end: undefined
                            }
                        })
                    }}>
                    X
                </CustomButton>
            </Col>
        </Row>

    )
}
export { CustomDateRangePicker as RangePicker }

const NewCustomDatePicker = ({
    name = "",
    value = undefined,
    onValueChange = () => { },
    onChange = () => { },
    defaultValue,
    placeholder,
    options,
    format = "YYYY-MM-DD",
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;

    const [open, setOpen] = useState(false);
    const popoverRef = useRef(null);

    const handleFocusOut = (event) => {
        if (
            popoverRef.current &&
            !popoverRef.current.contains(event.relatedTarget)
        ) {
            setOpen(false);
        }
    };

    useEffect(() => {
        const currentPopoverRef = popoverRef.current;
        if (currentPopoverRef) {
            currentPopoverRef.addEventListener("focusout", handleFocusOut);
        }

        return () => {
            if (currentPopoverRef) {
                currentPopoverRef.removeEventListener(
                    "focusout",
                    handleFocusOut
                );
            }
        };
    }, []);
    return (
        <>
            <DropdownMenu open={open} ref={popoverRef}>
                <DropdownMenuTrigger asChild>
                    <Button
                        variant={"outline"}
                        className={cn(
                            "w-[240px] pl-3 text-left font-normal",
                            !value && "text-muted-foreground"
                        )}
                        onClick={() => setOpen(true)}
                    >
                        {value ? (
                            dayjs(value).format(format)
                        ) : (
                            <span>Pick a date</span>
                        )}
                        <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-auto p-0" align="start">
                    {control ? (
                        <Controller
                            name={name}
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <Calendar
                                    mode="single"
                                    selected={dayjs(value).format(format)}
                                    onSelect={(date, ...e) => {
                                        onValueChange({
                                            target: {
                                                name,
                                                value: dayjs(
                                                    date.toLocaleDateString()
                                                ),
                                            },
                                        });
                                        onChange({
                                            target: {
                                                name,
                                                value: dayjs(
                                                    date.toLocaleDateString()
                                                ),
                                            },
                                        });
                                        setOpen(false);
                                    }}
                                    initialFocus
                                />
                            )}
                        />
                    ) : (
                        <Calendar
                            mode="single"
                            selected={value}
                            onSelect={(date, ...e) => {
                                onChange(
                                    date,
                                    dayjs(date).format(format),
                                    ...e
                                );
                                onValueChange(
                                    date,
                                    dayjs(date).format(format),
                                    ...e
                                );
                                setOpen(false);
                            }}
                            initialFocus
                        />
                    )}
                </DropdownMenuContent>
            </DropdownMenu>
        </>
    );
};

const NewCustomDatePickerIncludeMinute = ({
    name = "",
    value = undefined,
    onValueChange = () => { },
    onChange = () => { },
    defaultValue,
    placeholder,
    options,
    format = "YYYY-MM-DD HH:mm:ss", // 使用 YYYY-MM-DD HH:mm:ss 格式
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;

    const [open, setOpen] = useState(false);
    const popoverRef = useRef(null);

    const handleFocusOut = (event) => {
        if (
            popoverRef.current &&
            !popoverRef.current.contains(event.relatedTarget)
        ) {
            setOpen(false);
        }
    };

    useEffect(() => {
        const currentPopoverRef = popoverRef.current;
        if (currentPopoverRef) {
            currentPopoverRef.addEventListener("focusout", handleFocusOut);
        }

        return () => {
            if (currentPopoverRef) {
                currentPopoverRef.removeEventListener(
                    "focusout",
                    handleFocusOut
                );
            }
        };
    }, []);
    return (
        <>
            <DropdownMenu open={open} ref={popoverRef}>
                <DropdownMenuTrigger asChild>
                    <Button
                        variant={"outline"}
                        className={cn(
                            "w-[240px] pl-3 text-left font-normal",
                            !value && "text-muted-foreground"
                        )}
                        onClick={() => setOpen(true)}
                    >
                        {value ? (
                            dayjs(value).format(format)
                        ) : (
                            <span>Pick a date</span>
                        )}
                        <CalendarIcon className="ml-auto h-4 w-4 opacity-50" />
                    </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-auto p-0" align="start">
                    {control ? (
                        <Controller
                            name={name}
                            control={control}
                            render={({ field, fieldState: { error } }) => (
                                <DatePicker
                                    showTimeSelect // 顯示時間選擇
                                    timeFormat="HH:mm" // 設置時間格式為24小時制，精確到分鐘
                                    timeIntervals={1} // 分鐘間隔
                                    dateFormat="Pp" // 顯示秒的格式
                                    selected={value ? new Date(value) : null} // 改成 Date 對象
                                    placeholderText="選擇日期和時間"
                                    onClickOutside={() => setOpen(false)} // 點擊外部時關閉選擇器
                                    inline
                                    onChange={(date) => {
                                        onValueChange({
                                            target: {
                                                name,
                                                value: dayjs(date).format(format), // 使用 Date 對象
                                            },
                                        });
                                        onChange({
                                            target: {
                                                name,
                                                value: dayjs(date).format(format),
                                            },
                                        });
                                        setOpen(false);
                                    }}
                                    initialFocus
                                />
                            )}
                        />
                    ) : (
                        <DatePicker
                            showTimeSelect // 顯示時間選擇
                            timeFormat="HH:mm" // 設置時間格式為24小時制，精確到分鐘
                            timeIntervals={1} // 分鐘間隔
                            dateFormat="Pp" // 顯示秒的格式
                            selected={value ? new Date(value) : null} // 改成 Date 對象
                            placeholderText="選擇日期和時間"
                            onClickOutside={() => setOpen(false)} // 點擊外部時關閉選擇器
                            inline
                            onChange={(date, ...e) => {
                                onChange(
                                    date,
                                    dayjs(date).format(format),
                                    ...e
                                );
                                onValueChange(
                                    date,
                                    dayjs(date).format(format),
                                    ...e
                                );
                                setOpen(false);
                            }}
                            initialFocus
                        />
                    )}
                </DropdownMenuContent>
            </DropdownMenu>
        </>
    );
};
NewCustomDatePicker.DatePickerIncludeMinute = NewCustomDatePickerIncludeMinute
export { NewCustomDatePicker as NewDatePicker };

const CustomCard = ({
    actions,
    activeTabKey,
    bordered = true,
    cover,
    defaultActiveTabKey,
    extra,
    hoverable,
    loading,
    size = "default",
    tabBarExtraContent,
    tabList,
    tabProps,
    title,
    type,
    classNames,
    styles = {
        padding: 16,
    },
    onTabChange,
    children,
    headerParallel = false,
    icon = false,
    description = "",
}) => {
    const [currentTabKey, setCurrentTabKey] = useState(defaultActiveTabKey);

    const handleTabChange = (key) => {
        setCurrentTabKey(key);
        if (onTabChange) {
            onTabChange(key);
        }
    };

    const renderTabs = () => {
        if (!tabList) return null;
        return (
            <div className="card-tabs">
                {tabList.map((tab) => (
                    <div
                        key={tab.key}
                        className={`card-tab ${tab.key === currentTabKey ? "active" : ""
                            }`}
                        onClick={() => handleTabChange(tab.key)}
                    >
                        {tab.tab}
                    </div>
                ))}
            </div>
        );
    };

    return (
        <Card
            className={`${bordered ? "bordered" : ""} ${hoverable ? "hoverable" : ""
                } ${classNames || ""}`}
            style={styles}
        >
            {(title || extra) && (
                <CardHeader className={`${size} ${type}`}>
                    <div className={headerParallel ? "flex gap-4" : ""}>
                        {icon && <FileEdit />}
                        <div>
                            {title && <CardTitle>{title}</CardTitle>}
                            {description && <CardDescription>{description}</CardDescription>}
                        </div>
                        {extra && <div className="card-extra">{extra}</div>}
                    </div>
                </CardHeader>
            )}
            {cover && <div className="card-cover">{cover}</div>}
            {renderTabs()}
            <CardContent className={'p-0'}>
                {loading ? (
                    <div className="card-loading">Loading...</div>
                ) : (
                    children
                )}
            </CardContent>
            {actions && actions.length > 0 && (
                <CardFooter className="card-actions">
                    {actions.map((action, index) => (
                        <div key={index} className="card-action">
                            {action}
                        </div>
                    ))}
                </CardFooter>
            )}
        </Card>
    );
};
export { CustomCard as Card };

const HomeOutlined = ({ ...props }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                {...props}
            >
                <path
                    stroke="#1C274C"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M22 22H2M2 11l8.126-6.5a3 3 0 013.748 0L22 11"
                ></path>
                <path
                    stroke="#1C274C"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M15.5 5.5v-2A.5.5 0 0116 3h2.5a.5.5 0 01.5.5v5"
                    opacity="0.5"
                ></path>
                <path
                    stroke="#1C274C"
                    strokeLinecap="round"
                    strokeWidth="1.5"
                    d="M4 22V9.5M20 22V9.5"
                ></path>
                <path
                    stroke="#1C274C"
                    strokeWidth="1.5"
                    d="M15 22v-5c0-1.414 0-2.121-.44-2.56C14.122 14 13.415 14 12 14c-1.414 0-2.121 0-2.56.44C9 14.878 9 15.585 9 17v5M14 9.5a2 2 0 11-4 0 2 2 0 014 0z"
                    opacity="0.5"
                ></path>
            </svg>
        </>
    );
};
const AudioFilled = ({ ...props }) => {
    return <>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            version="1.1"
            viewBox="0 0 261.075 261.075"
            xmlSpace="preserve"
            {...props}
        >
            <g fill="#010002">
                <path d="M126.855 174.05h5.744c22.447 0 40.641-18.194 40.641-40.641V40.641C173.24 18.194 155.046 0 132.599 0h-5.744c-22.447 0-40.641 18.194-40.641 40.641v92.769c.001 22.446 18.194 40.64 40.641 40.64z"></path>
                <path d="M124.288 201.147v43.61H86.215c-4.504 0-8.159 3.65-8.159 8.159s3.655 8.159 8.159 8.159h92.464c4.504 0 8.159-3.65 8.159-8.159s-3.655-8.159-8.159-8.159h-38.073v-43.823c34.832-3.138 63.262-34.44 63.262-71.208 0-4.509-3.655-8.159-8.159-8.159s-8.159 3.65-8.159 8.159c0 29.92-24.122 55.201-52.672 55.201h-8.686c-28.544 0-52.666-24.699-52.666-53.939 0-4.509-3.655-8.159-8.159-8.159s-8.159 3.65-8.159 8.159c0 38.085 29.926 69.121 67.08 70.159z"></path>
            </g>
        </svg>
    </>
}
const PlusOutlined = ({ ...props }) => {
    return (
        <>
            <span {...props}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke="#000"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 12h16m-8-8v16"
                    ></path>
                </svg>
            </span>
        </>
    );
};

const containerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
};

const uploadButtonStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #d9d9d9",
    borderRadius: "2px",
    width: "100px",
    height: "100px",
    background: "#fafafa",
    cursor: "pointer",
};

const thumbsContainerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 16,
};

const thumbStyle = {
    display: "inline-flex",
    borderRadius: 2,
    border: "1px solid #eaeaea",
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: "border-box",
};

const thumbInnerStyle = {
    display: "flex",
    minWidth: 0,
    overflow: "hidden",
    position: "relative",
};

const imgStyle = {
    display: "block",
    width: "auto",
    height: "100%",
};

const CustomUpload = ({
    name = undefined,
    accept = "image/*",
    customRequest = () => { },
    fileList = [],
    onPreview = () => { },
    onRemove = () => { },
    beforeUpload = () => true,
    onChange = () => { },
    onValueChange = () => { },
    multiple = false,
    disabled = false,
    propsFullPreview = false,
    propsThumbStyle = {},
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    const [files, setFiles] = useState(undefined);

    const { getRootProps, getInputProps } = useDropzone({
        accept,
        multiple,
        onDrop: (acceptedFiles) => {
            const newFiles = acceptedFiles.map((file) =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })
            );
            if (name) {
                onChange({
                    target: {
                        name,
                        value: acceptedFiles?.find((_) => true)
                    }
                })
                onValueChange({
                    target: {
                        name,
                        value: acceptedFiles?.find((_) => true)
                    }
                })
            } else {
                onChange(acceptedFiles?.find((_) => true))
            }
            setFiles((prevFiles) => [
                ...(prevFiles || fileList || []),
                ...newFiles,
            ]);
            customRequest({
                file: acceptedFiles?.find((_) => true),
            });
        },
    });

    const handleRemove = (file) => {
        setFiles((prevFiles) => (prevFiles || fileList || []).filter((f) => f !== file));
        onRemove(file);
    };

    const thumbs = (files || fileList)?.map((file) => (
        <div style={{
            ...thumbStyle,
            ...propsThumbStyle,
            ...(propsFullPreview ? {
                width: undefined,
                height: undefined,
            } : {})
        }} key={file.name}>
            <div style={thumbInnerStyle}>
                <img
                    src={file.preview}
                    style={imgStyle}
                    onLoad={() => URL.revokeObjectURL(file.preview)}
                    onClick={() => onPreview(file)}
                />
                {
                    !disabled &&
                    <button
                        style={{ position: "absolute", top: 0, right: 0 }}
                        onClick={() => handleRemove(file)}
                    >
                        X
                    </button>
                }

            </div>
        </div>
    ));


    return (
        <div style={containerStyle}>
            {
                !disabled &&
                <div
                    hidden={disabled}
                    {...getRootProps({
                        className: "dropzone",
                        style: uploadButtonStyle,
                    })}
                >
                    <input type={'file'} disabled={disabled} {...getInputProps()} />
                    <PlusOutlined style={{ fontSize: 24, color: "#1890ff" }} />
                    <div style={{ marginTop: 8 }}>上傳</div>
                </div>
            }
            <aside style={thumbsContainerStyle}>{thumbs}</aside>
        </div>
    );
};

export { CustomUpload as Upload };

const LayoutFlow = ({ data }) => {
    const dagreGraph = new dagre.graphlib.Graph();
    dagreGraph.setDefaultEdgeLabel(() => ({}));

    const nodeWidth = 172;
    const nodeHeight = 36;

    const getLayoutedElements = (nodes, edges, direction = "TB") => {
        const isHorizontal = direction === "LR";
        dagreGraph.setGraph({ rankdir: direction });

        nodes.forEach((node) => {
            dagreGraph.setNode(node.id, {
                width: nodeWidth,
                height: nodeHeight,
            });
        });

        edges.forEach((edge) => {
            dagreGraph.setEdge(edge.source, edge.target);
        });

        dagre.layout(dagreGraph);

        const newNodes = nodes.map((node) => {
            const nodeWithPosition = dagreGraph.node(node.id);
            const newNode = {
                ...node,
                targetPosition: isHorizontal ? "left" : "top",
                sourcePosition: isHorizontal ? "right" : "bottom",
                // We are shifting the dagre node position (anchor=center center) to the top left
                // so it matches the React Flow node anchor point (top left).
            };

            return newNode;
        });

        return { nodes: newNodes, edges };
    };
    const [nodes, setNodes, onNodesChange] = useNodesState([]);
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);

    const onConnect = useCallback(
        (params) =>
            setEdges((eds) =>
                addEdge(
                    {
                        ...params,
                        type: ConnectionLineType.SmoothStep,
                        animated: true,
                    },
                    eds
                )
            ),
        []
    );

    const generateNodesAndEdges = (
        item,
        parentId = null,
        pos = { x: 0, y: 0 }
    ) => {
        const nodes = [];
        const edges = [];
        const nodeId = item.classify_structure_type_id.toString();
        nodes.push({
            id: nodeId,
            type: parentId ? "default" : "input",
            data: { label: item.name },
            position: pos,
        });

        if (parentId) {
            edges.push({
                id: `e${parentId}-${nodeId}`,
                source: parentId,
                target: nodeId,
                type: "smoothstep",
                animated: true,
            });
        }

        const numChildren = item.children.length;
        const totalWidth = (numChildren - 1) * 200;
        const startX = pos.x - totalWidth / 2;

        item.children.forEach((child, index) => {
            const childPos = { x: startX + index * 200, y: pos.y + 100 };
            const result = generateNodesAndEdges(child, nodeId, childPos);
            nodes.push(...result.nodes);
            edges.push(...result.edges);
        });

        return { nodes, edges };
    };

    useEffect(() => {
        if (data) {
            const { nodes, edges } = generateNodesAndEdges(data);
            setNodes(nodes);
            setEdges(edges);
        }
    }, [data]);

    return (
        <ReactFlow
            style={{ minHeight: "500px" }}
            nodes={nodes}
            edges={edges}
            onNodesChange={onNodesChange}
            onEdgesChange={onEdgesChange}
            onConnect={onConnect}
            connectionLineType={ConnectionLineType.SmoothStep}
            fitView
        ></ReactFlow>
    );
};
export { LayoutFlow as OrganizationGraph };

const Transfer = ({
    dataSource,
    targetKeys,
    onChange,
    render,
    showSearch,
    listStyle,
}) => {
    const [searchLeft, setSearchLeft] = useState("");
    const [searchRight, setSearchRight] = useState("");
    const [leftItems, setLeftItems] = useState([]);
    const [rightItems, setRightItems] = useState([]);

    useEffect(() => {
        const left = dataSource.filter(
            (item) => !targetKeys.includes(item.key)
        );
        const right = dataSource.filter((item) =>
            targetKeys.includes(item.key)
        );
        setLeftItems(left);
        setRightItems(right);
    }, [dataSource]);

    const handleSearchLeft = (event) => {
        setSearchLeft(event.target.value);
    };
    const handleSearchRight = (event) => {
        setSearchRight(event.target.value);
    };

    const handleTransfer = (
        source,
        setSource,
        destination,
        setDestination,
        keys
    ) => {
        const newSource = source.filter((item) => !keys.includes(item.key));
        const newDestination = [
            ...destination,
            ...keys.map((key) => dataSource.find((item) => item.key === key)),
        ];

        setSource(newSource);
        setDestination(newDestination);
        onChange(newDestination.map((item) => item.key));
    };

    const handleTransferAll = (
        source,
        setSource,
        destination,
        setDestination
    ) => {
        const keys = source.map((item) => item.key);
        handleTransfer(source, setSource, destination, setDestination, keys);
    };

    const filteredLeftItems = leftItems.filter((item) =>
        item.title.includes(searchLeft)
    );
    const filteredRightItems = rightItems.filter((item) =>
        item.title.includes(searchRight)
    );

    return (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "45%" }}>
                {showSearch && (
                    <input
                        placeholder="搜尋..."
                        value={searchLeft}
                        onChange={handleSearchLeft}
                    />
                )}
                <div
                    style={{
                        ...listStyle,
                        overflow: "auto",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                    }}
                >
                    {filteredLeftItems.map((item) => (
                        <div key={item.key}>
                            <label>
                                <input
                                    type="checkbox"
                                    value={item.key}
                                    onChange={(e) =>
                                        handleTransfer(
                                            leftItems,
                                            setLeftItems,
                                            rightItems,
                                            setRightItems,
                                            [e.target.value]
                                        )
                                    }
                                />
                                {render(item)}
                            </label>
                        </div>
                    ))}
                </div>
                <button
                    onClick={() =>
                        handleTransferAll(
                            leftItems,
                            setLeftItems,
                            rightItems,
                            setRightItems
                        )
                    }
                >
                    全部往右
                </button>
            </div>
            <div style={{ width: "45%" }}>
                {showSearch && (
                    <input
                        placeholder="搜尋..."
                        value={searchRight}
                        onChange={handleSearchRight}
                    />
                )}
                <div
                    style={{
                        ...listStyle,
                        overflow: "auto",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                    }}
                >
                    {filteredRightItems.map((item) => (
                        <div key={item.key}>
                            <label>
                                <input
                                    type="checkbox"
                                    value={item.key}
                                    onChange={(e) =>
                                        handleTransfer(
                                            rightItems,
                                            setRightItems,
                                            leftItems,
                                            setLeftItems,
                                            [e.target.value]
                                        )
                                    }
                                />
                                {render(item)}
                            </label>
                        </div>
                    ))}
                </div>
                <button
                    onClick={() =>
                        handleTransferAll(
                            rightItems,
                            setRightItems,
                            leftItems,
                            setLeftItems
                        )
                    }
                >
                    全部往左
                </button>
            </div>
        </div>
    );
};
export { Transfer };
const CheckCircleOutlined = ({ ...props }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                {...props}
            >
                <circle
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="#1C274C"
                    strokeWidth="1.5"
                ></circle>
                <path
                    stroke="#1C274C"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M8.5 12.5l2 2 5-5"
                ></path>
            </svg>
        </>
    );
};
const CloseCircleOutlined = ({ ...props }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                {...props}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 9l6 6m0-6l-6 6m12-3a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
            </svg>
        </>
    );
};
const ExclamationCircleOutlined = ({ ...props }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 20 20"
                {...props}
            >
                <path
                    fillRule="evenodd"
                    d="M10 3a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1118 0 9 9 0 01-18 0zm10.01 4a1 1 0 01-1 1H10a1 1 0 110-2h.01a1 1 0 011 1zM11 6a1 1 0 10-2 0v5a1 1 0 102 0V6z"
                ></path>
            </svg>
        </>
    );
};
const UserOutlined = ({ ...props }) => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                {...props}
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                ></path>
            </svg>
        </>
    );
};
export {
    PlusOutlined,
    CheckCircleOutlined,
    CloseCircleOutlined,
    ExclamationCircleOutlined,
    UserOutlined,
    HomeOutlined,
    AudioFilled,
};

const Tag = ({ color = "primary", icon = <></>, children, ...props }) => {
    const colors = {
        default: { backgroundColor: "#e8e8e8", textColor: "#000" },
        primary: { backgroundColor: "#1890ff", textColor: "#fff" },
        secondary: { backgroundColor: "#grey", textColor: "#fff" },
        error: { backgroundColor: "#fff2f0", textColor: "#ff4d4f" },
        success: { backgroundColor: "lightgreen", textColor: "darkgreen" },
        blue: { backgroundColor: "lightblue", textColor: "darkblue" },
        green: { backgroundColor: "lightgreen", textColor: "darkgreen" },
        geekblue: {
            border: "#adc6ff 1px solid",
            backgroundColor: "#f0f5ff",
            textColor: "#1d39c4",
        },
        outline: {
            backgroundColor: "transparent",
            textColor: "#000",
            border: "1px solid #d9d9d9",
        },
        "gold-inverse": {
            backgroundColor: "#faad14",
            textColor: "#fff",
            border: "1px solid #faad14",
        },
        "cyan-inverse": {
            backgroundColor: "#13c2c2",
            textColor: "#fff",
            border: "1px solid #13c2c2",
        },
        // Add other color mappings as needed
    };

    const styles = colors[color] || colors.default;

    return (
        <>
            <Badge
                style={{
                    backgroundColor: styles.backgroundColor,
                    color: styles.textColor,
                    border: styles.border || "none",
                    display: "inline-flex",
                    alignItems: "center",
                    padding: "0 8px",
                    fontSize: "12px",
                    borderRadius: "2px",
                    ...props.style,
                }}
                {...props}
            >
                {icon &&
                    React.cloneElement(icon, {
                        style: {
                            fill: styles.backgroundColor,
                            stroke: styles.textColor,
                            marginRight: "4px",
                        },
                    })}
                {children}
            </Badge>
        </>
    );
};
export { Tag };
const customMessage = () => {
};

customMessage.open = ({ type, content }) => {
    const createContainer = () => {
        const container = document.createElement("div");
        document.getElementById("root").appendChild(container);
        return container;
    };

    const renderToaster = (container) => {
        const root = createRoot(container);
        root.render(
            <>
                <CustomToaster />
            </>
        );
        return root;
    };

    const cleanup = (root, container) => {
        setTimeout(() => {
            root.unmount();
            document.getElementById("root").removeChild(container);
        }, 5000); // Adjust the timeout as needed
    };

    const go = (type, content) => {
        switch (type) {
            case "success":
                toast.success(content);
                break;
            case "info":
                toast.info(content);
                break;
            case "warning":
                toast.warning(content);
                break;
            case "error":
                toast.error(content);
                break;
            case "message":
                toast.content(content);
                break;
            case "loading":
                toast.loading(content);
                break;

            default:
                break;
        }
    }
    if (document.getElementById(toasterId) === null) {
        const container = createContainer();
        const root = renderToaster(container);
        setTimeout(() => {
            go(type, content);
        }, 1000)
    } else {
        go(type, content);

    }
};
customMessage.success = (content) =>
    customMessage.open({ type: "success", content: content });
customMessage.info = (content) =>
    customMessage.open({ type: "info", content: content });
customMessage.warning = (content) =>
    customMessage.open({ type: "warning", content: content });
customMessage.error = (content) =>
    customMessage.open({ type: "error", content: content });
customMessage.message = (content) =>
    customMessage.open({ type: "message", content: content });
customMessage.loading = (content) =>
    customMessage.open({ type: "loading", content: content });

const toasterId = "global-sonner-toaster";
const CustomToaster = ({ ...props }) => {
    if (document.getElementById(toasterId) === null) {
        return (
            <>
                <div id={toasterId}>
                    <Toaster richColors position="top-center" {...props} />
                </div>
            </>
        );
    } else {
        return <></>;
    }
};
export { CustomToaster as Toaster };

const useMessage = () => {
    const createContainer = () => {
        const container = document.createElement("div");
        document.getElementById("root").appendChild(container);
        return container;
    };

    const renderToaster = (container) => {
        const root = createRoot(container);
        root.render(
            <>
                <CustomToaster />
            </>
        );
        return root;
    };

    const cleanup = (root, container) => {
        setTimeout(() => {
            root.unmount();
            document.getElementById("root").removeChild(container);
        }, 5000); // Adjust the timeout as needed
    };
    if (document.getElementById(toasterId) === null) {
        const container = createContainer();
        const root = renderToaster(container);
    }

    return [customMessage];
};
customMessage.useMessage = useMessage;
export { customMessage as message };

// const TreeSelect = ({ name, onValueChange = () => { }, multiple = false, defaultValue = [], showSearch, style, dropdownStyle, placeholder, allowClear, treeDefaultExpandAll, treeNodeFilterProp, onChange = () => { }, treeData, ...props }) => {
//     const transformTreeData = (data) => {
//         const transformNode = (node) => {
//             const internalDefaultValue = defaultValue ? (Array.isArray(defaultValue) ? defaultValue : [defaultValue]).map(String) : [];
//             const propsValue = (Array.isArray(props?.value) ? props?.value : [props?.value]).map(String);
//             const endValue = props?.value ? propsValue : internalDefaultValue
//             return {
//                 label: node.title,
//                 value: String(node.value),
//                 checked: endValue?.includes(String(node.value)),
//                 expanded: treeDefaultExpandAll,
//                 children: node?.children?.length > 0 ? node.children.map(transformNode) : [],
//             };
//         };

//         return data.map(transformNode);
//     };
//     useEffect(() => {
//         if (defaultValue == []) {
//             const values = defaultValue ? (Array.isArray(defaultValue) ? defaultValue : [defaultValue]).map(String) : [];
//             onChange({
//                 target: {
//                     name,
//                     value: multiple ? values : undefined
//                 }
//             })
//             onValueChange({
//                 target: {
//                     name,
//                     value: multiple ? values : undefined
//                 }
//             });
//         }
//     }, [])
//     const mode = multiple ? "hierarchical" : "radioSelect"
//     return (
//         <DropdownTreeSelect
//             {...props}
//             onBlur={() => { }}
//             mode={mode}
//             data={transformTreeData(treeData)}
//             onChange={(currentNode, selectedNodes) => {
//                 let selectedValue = String(selectedNodes.map(node => node.value)?.find(_ => true));
//                 if (multiple ?? mode === "hierarchical") {
//                     selectedValue = selectedNodes.map(node => String(node.value))
//                 }
//                 onChange({
//                     target: {
//                         name,
//                         value: selectedValue,
//                         selectedNodes
//                     }
//                 })
//                 onValueChange({
//                     target: {
//                         name,
//                         value: selectedValue,
//                         selectedNodes
//                     }
//                 });
//             }}
//             // onBlur={() => { }}
//             texts={{ placeholder }}
//         />
//     );
// };
const CustomSwitch2 = ({
    name,
    onValueChange = () => { },
    onChange,
    value,
    mode = 'boolean',
    checkedChildren, //確認時顯示文字
    unCheckedChildren, //關閉時顯示文字
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    const isChecked = (checked) => {
        if (typeof checked === "number" | typeof checked === "string") {
            if (checked === 1 | checked === "true" | checked === "1") {
                return true;
            } else {
                return false;
            }
        } else if (typeof checked === "boolean") {
            return checked;
        } else if (typeof checked === "number") {
            if (checked === 1) {
                return true;
            } else {
                return false;
            }
        }
    };

    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <CustomSwitchWithMore
                            className={
                                isChecked(value) ? "data-[state=checked]" : ""
                            }
                            checked={isChecked(value)}
                            onCheckedChange={(e) => {
                                let value = e;
                                if (mode === "number") {
                                    value = e ? "1" : "0"
                                } else {
                                    value = e
                                }
                                onChange({
                                    target: {
                                        name,
                                        value: value,
                                        checked: value,
                                    },
                                });
                                onValueChange({
                                    target: {
                                        name,
                                        value: value,
                                        checked: value,
                                    },
                                });
                            }}
                            checkedChildren={checkedChildren}
                            unCheckedChildren={unCheckedChildren}
                            {...props}
                        />
                    )}
                />
            ) : (
                <CustomSwitchWithMore
                    checked={value}
                    onCheckedChange={(e) => {
                        let value = e;
                        if (mode === "number") {
                            value = e ? "1" : "0"
                        } else {
                            value = e
                        }
                        onChange({
                            target: {
                                name,
                                value: value,
                            },
                        });
                        onValueChange({
                            target: {
                                name,
                                value: value,
                            },
                        });
                    }}
                    checkedChildren={checkedChildren}
                    unCheckedChildren={unCheckedChildren}
                    {...props}
                />
            )}
        </>
    );
};
export { CustomSwitch2 as Switch };

const InputPassword = ({ className,
    placeholder,
    ...props }) => {
    const [value, setValue] = useState(String(props?.value) || 0)
    const [showPassword, setShowPassword] = React.useState(false)

    useEffect(() => {
        setValue(props?.value)
    }, [props?.value])
    return <>

        {props?.name ? (
            <div className="relative">
                <Input
                    type={showPassword ? 'text' : 'password'}
                    className={cn('hide-password-toggle pr-10', className)}
                    value={value}
                    placeholder={placeholder}
                    onChange={e => {
                        props?.onValueChange({
                            target: {
                                name: props?.name,
                                value: e.target.value
                            }
                        });
                        props?.onChange({
                            target: {
                                name: props?.name,
                                value: e.target.value
                            }
                        });
                        setValue(e.target.value)
                    }}
                />
                <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
                    onClick={() => setShowPassword((prev) => !prev)}
                >
                    {showPassword ? (
                        <Eye className="h-4 w-4" aria-hidden="true" />
                    ) : (
                        <EyeOff className="h-4 w-4" aria-hidden="true" />
                    )}
                    <span className="sr-only">{showPassword ? 'Hide password' : 'Show password'}</span>
                </Button>

                {/* hides browsers password toggles */}
                <style>{`
                 .hide-password-toggle::-ms-reveal,
                 .hide-password-toggle::-ms-clear {
                     visibility: hidden;
                     pointer-events: none;
                     display: none;
                 }
             `}</style>
            </div>
        )
            :
            <div className="relative">
                <Input
                    type={showPassword ? 'text' : 'password'}
                    className={cn('hide-password-toggle pr-10', className)}
                    placeholder={placeholder}
                    {...props}
                />
                <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
                    onClick={() => setShowPassword((prev) => !prev)}
                >
                    {showPassword ? (
                        <Eye className="h-4 w-4" aria-hidden="true" />
                    ) : (
                        <EyeOff className="h-4 w-4" aria-hidden="true" />
                    )}
                    <span className="sr-only">{showPassword ? 'Hide password' : 'Show password'}</span>
                </Button>

                {/* hides browsers password toggles */}
                <style>{`
                    .hide-password-toggle::-ms-reveal,
                    .hide-password-toggle::-ms-clear {
                        visibility: hidden;
                        pointer-events: none;
                        display: none;
                    }
                `}</style>
            </div>
        }
    </>;
};

Input.Password = InputPassword
Input.TextArea = Textarea
export { Input };

const CustomPie = ({ ...config }) => {
    const {
        appendPadding = 10,
        data = [],
        angleField = "value",
        colorField = "type",
        radius = 0.9,
        label = {
            type: "inner",
            offset: "-30%",
            content: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
            style: {
                fontSize: 15,
                textAlign: "center",
            },
        },
        interactions = [
            {
                type: "element-active",
            },
        ],
        style = { maxHeight: "20vh" },
    } = config;
    const svgRef = useRef();
    function vhToPixels(vh) {
        return Math.round(window.innerHeight * (vh / 100));
    }

    useEffect(() => {
        const internalData = data.filter((item) => item.value !== 0);
        const svg = d3.select(svgRef.current);
        const width = String(style?.maxHeight).indexOf("vh")
            ? vhToPixels(parseInt(String(style?.maxHeight).replace("vh", "")))
            : style?.maxHeight || 400;
        const height = width;
        const radius = (Math.min(width, height) / 2) * config.radius;

        // Clear previous chart
        svg.selectAll("*").remove();

        // Setup the svg element
        svg.attr("width", width).attr("height", height);
        const g = svg
            .append("g")
            .attr("transform", `translate(${width / 2}, ${height / 2})`);

        // Setup color scale
        const color = d3.scaleOrdinal(d3.schemeCategory10);

        // Generate the pie
        const pie = d3
            .pie()
            .sort(null)
            .value((d) => d[config.angleField]);

        // Generate the arcs
        const arc = d3.arc().innerRadius(0).outerRadius(radius);

        // Generate the arcs for labels
        const labelArc = d3
            .arc()
            .innerRadius(radius * 0.6)
            .outerRadius(radius * 0.6);

        // Append the arcs
        const path = g
            .selectAll("path")
            .data(pie(internalData))
            .enter()
            .append("path")
            .attr("d", arc)
            .attr("fill", (d) => color(d.data[config.colorField]));

        // Append the labels
        g.selectAll("text")
            .data(pie(internalData))
            .enter()
            .append("text")
            .attr("transform", (d) => `translate(${labelArc.centroid(d)})`)
            .attr("dy", "0.35em")
            .attr("text-anchor", "middle")
            .style("font-size", `${config.label.style.fontSize}px`)
            .text(
                (d) =>
                    `${d.data?.type}：${Math.round(
                        (d.data[config.angleField] /
                            d3.sum(data, (d) => d[config.angleField])) *
                        100
                    )}%`
            );

        // Interaction for element active
        path.on("mouseover", function () {
            d3.select(this)
                .transition()
                .duration(200)
                .attr(
                    "d",
                    d3
                        .arc()
                        .innerRadius(0)
                        .outerRadius(radius * 1.1)
                );
        });
        path.on("mouseout", function () {
            d3.select(this).transition().duration(200).attr("d", arc);
        });
    }, [data, config]);

    return <svg ref={svgRef} style={config.style} />;
};
export { CustomPie as Pie };

const CustomPieChart = (config) => {
    const { data, angleField, colorField, label, legend } = config;

    // 設定每個 Pie 的顏色
    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF', '#FF1A75'];

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <PieChart width={500} height={300}>
                <Pie
                    data={data}
                    dataKey={angleField}
                    nameKey={colorField}
                    cx="50%"
                    cy="50%"
                    outerRadius={100}
                    label={label ? ({ value }) => label.text : null}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                {legend && <Legend verticalAlign="right" align="right" layout="vertical" />}
            </PieChart>
        </div>
    );
};

export { CustomPieChart as PieChart };
const CustomCheckbox = ({ children, ...props }) => {
    return (
        <>
            <div className="flex items-center space-x-2">
                <Checkbox {...props} />
                <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                    {children}
                </label>
            </div>
        </>
    );
};
const CustomCheckboxGroup = ({
    defaultValue = [],
    disabled = false,
    name,
    options = [],
    value: controlledValue,
    onChange,
    style,
    children,
}) => {
    const [selectedValues, setSelectedValues] = useState(
        controlledValue || defaultValue
    );

    useEffect(() => {
        if (controlledValue !== undefined) {
            setSelectedValues(controlledValue);
        }
    }, [controlledValue]);

    const handleChange = (checked, optionValue) => {
        const newValues = checked
            ? [...selectedValues, optionValue]
            : selectedValues.filter((val) => val !== optionValue);
        if (controlledValue === undefined) {
            setSelectedValues(newValues);
        }

        if (onChange) {
            onChange({
                target: {
                    name,
                    value: newValues
                }
            });
        }
    };

    const renderChildren = (children) => {
        return React.Children.map(children, (child) => {
            if (child && child?.type === CustomCheckbox) {
                return cloneElement(child, {
                    checked: selectedValues.includes(child.props.value),
                    onCheckedChange: (e) => {
                        handleChange(e, child.props.value);
                    },
                    disabled: disabled || child.props.disabled,
                    name,
                });
            }
            if (child && child.props && child.props.children) {
                return cloneElement(child, {
                    children: renderChildren(child.props.children),
                });
            }
            return child;
        });
    };
    return (
        <div style={style}>
            <Row gutter={[16, 16]}>
                {options.length > 0
                    ? options.map((option) => (
                        <Col span={24} key={option.value}>
                            <CustomCheckbox
                                checked={selectedValues.includes(
                                    option.value
                                )}
                                onChange={(e) => {
                                    handleChange(
                                        e.target.checked,
                                        option.value
                                    );
                                }}
                                onCheckedChange={(e) => {
                                    handleChange(e, option.value);
                                }}
                                value={option.value}
                                disabled={disabled || option.disabled}
                                name={name}
                            >
                                {option.label}
                            </CustomCheckbox>
                        </Col>
                    ))
                    : renderChildren(children)}
            </Row>
        </div>
    );
};
CustomCheckbox.Group = CustomCheckboxGroup;
export { CustomCheckbox as Checkbox };

const CustomCarousel = ({
    arrows = false,
    autoplay = false,
    autoplaySpeed = 3000,
    adaptiveHeight = false,
    dotPosition = "bottom",
    dots = true,
    draggable = false,
    fade = false,
    infinite = true,
    speed = 500,
    easing = "linear",
    effect = "scrollx",
    afterChange,
    beforeChange,
    waitForAnimate = false,
    children,
}) => {
    const [current, setCurrent] = useState(0);
    const [autoPlayId, setAutoPlayId] = useState(null);

    useEffect(() => {
        if (autoplay) {
            const id = setInterval(() => {
                const nextIndex =
                    (current + 1) % React.Children.count(children);
                handleChange(nextIndex);
            }, autoplaySpeed);
            setAutoPlayId(id);

            return () => clearInterval(id);
        }
    }, [autoplay, autoplaySpeed, current, children]);

    const handleChange = (nextIndex) => {
        if (beforeChange) {
            beforeChange(current, nextIndex);
        }

        if (!waitForAnimate || !fade) {
            setCurrent(nextIndex);
        }

        if (afterChange) {
            afterChange(nextIndex);
        }
    };

    return (
        <div className={`carousel-container ${dotPosition}`}>
            <Carousel
                index={current}
                onIndexChange={handleChange}
                transitionDuration={speed}
                transitionTimingFunction={easing}
                infinite={infinite}
                className={`${effect === "fade" ? "fade" : ""}`}
            >
                {React.Children.map(children, (child, index) => (
                    <CarouselItem
                        key={index}
                        className={`${adaptiveHeight ? "adaptive-height" : ""}`}
                    >
                        {child}
                    </CarouselItem>
                ))}
            </Carousel>

            {dots && (
                <div className={`dots ${dotPosition}`}>
                    {React.Children.map(children, (child, index) => (
                        <button
                            key={index}
                            className={`dot ${current === index ? "active" : ""
                                }`}
                            onClick={() => handleChange(index)}
                        />
                    ))}
                </div>
            )}

            {arrows && (
                <div className="arrows">
                    <button
                        className="arrow prev"
                        onClick={() =>
                            handleChange(
                                (current - 1 + React.Children.count(children)) %
                                React.Children.count(children)
                            )
                        }
                    >
                        {"<"}
                    </button>
                    <button
                        className="arrow next"
                        onClick={() =>
                            handleChange(
                                (current + 1) % React.Children.count(children)
                            )
                        }
                    >
                        {">"}
                    </button>
                </div>
            )}
        </div>
    );
};
export { CustomCarousel as Carousel };

const CustomAvatar = ({ size = "default", src, icon, ...props }) => {
    const sizeMap = {
        large: 64,
        default: 40,
        small: 32,
    };

    const sizeValue = typeof size === "string" ? sizeMap[size] : size;

    return (
        <>
            <Avatar
                style={{
                    width:
                        typeof sizeValue === "number" ? sizeValue : undefined,
                    height:
                        typeof sizeValue === "number" ? sizeValue : undefined,
                    fontSize:
                        typeof sizeValue === "number"
                            ? sizeValue / 2
                            : undefined,
                }}
                {...props}
            >
                {src ? (
                    <img
                        src={src}
                        alt="avatar"
                        style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "50%",
                        }}
                    />
                ) : (
                    React.cloneElement(icon, {
                        width:
                            typeof sizeValue === "number"
                                ? sizeValue
                                : undefined,
                        height:
                            typeof sizeValue === "number"
                                ? sizeValue
                                : undefined,
                        fontSize:
                            typeof sizeValue === "number"
                                ? sizeValue / 2
                                : undefined,
                        ...props,
                    }) || <></>
                )}
            </Avatar>
        </>
    );
};
export { CustomAvatar as Avatar };

const Seperator = styled.div`
    & {
        display: flex;
        align-items: center;
        text-align: center;
    }

    &::before,
    &::after {
        content: "";
        flex: 1;
        border-bottom: 1px solid #000;
    }

    &:not(:empty)::before {
        margin-right: 0.5em;
    }

    &:not(:empty)::after {
        margin-left: 0.5em;
    }
`;
export { Seperator };

const CustomTabs = ({
    activeKey,
    defaultActiveKey,
    items = [],
    onChange,
    animated = { inkBar: true, tabPane: false },
    centered = false,
    tabBarExtraContent,
    tabBarGutter,
    tabBarStyle,
    tabPosition = "top",
    destroyInactiveTabPane = false,
    type = "line",
    onEdit,
    onTabClick,
    onTabScroll,
    size = "middle",
    moreIcon,
    addIcon,
    hideAdd = false,
    popupClassName,
    renderTabBar,
    tabsStyle,
    tabsListStyle,
    tabsTriggerStyle,
    showRenderFunction = false,
    renderFunction = () => { },
    // new: fill=true makes tabs stretch to fill available width (evenly)
    fill = false,
}) => {
    const [activeTab, setActiveTab] = React.useState(
        defaultActiveKey ?? (items.length > 0 ? items[0].key : "")
    );
    React.useEffect(() => {
        if (activeKey !== undefined) {
            setActiveTab(activeKey);
        }
    }, [activeKey]);

    const handleTabChange = (key) => {
        setActiveTab(key);
        if (onChange) {
            onChange(key);
        }
    };

    return (
        <div
            className={`custom-tabs ${centered ? "centered" : ""}`}
            style={tabBarStyle}
        >
            {tabBarExtraContent && (
                <div className="tab-bar-extra-content">
                    {tabBarExtraContent}
                </div>
            )}
            <Tabs defaultValue={activeTab} onValueChange={handleTabChange} style={tabsStyle}>
                <TabsList className={cn("custom-tabs-list", fill ? "w-full" : "")} style={tabsListStyle}>
                    {items.map((item) => (
                        <TabsTrigger key={item.key} value={item.key} style={tabsTriggerStyle} className={fill ? 'flex-1' : undefined}>
                            {item.tab}
                        </TabsTrigger>
                    ))}
                </TabsList>
                {items.map((item) => (
                    <TabsContent key={item.key} value={item.key}>
                        {showRenderFunction ? renderFunction(item) : item.content}
                    </TabsContent>
                ))}
            </Tabs>
        </div >
    );
};

export { CustomTabs as Tabs };
export { TabsContent, TabsList, TabsTrigger }


const InputNumber = ({ min, max, disabled = false, ...props }) => {
    const formContext = useFormContext();
    const [value, setValue] = useState((props?.value || String(props?.value)) || 0)
    useEffect(() => {
        setValue(props?.value)
    }, [props?.value])
    return (
        <>
            {props?.name ? (
                <Input
                    // {...props}
                    disabled={disabled}
                    value={value !== 'null' ? value : undefined}
                    onChange={(e) => {
                        const floatRegex = /^-?\d*\.?\d*$/;
                        if (floatRegex.test(e.target.value)) {
                            let newValue = e.target.value
                            if (!!max && parseFloat(newValue) > parseFloat(max)) {
                                newValue = max
                            }
                            if (!!`${min}` && parseFloat(newValue) < parseFloat(min)) {
                                newValue = min
                            }
                            props?.onValueChange({
                                target: {
                                    name: props?.name,
                                    value: newValue
                                }
                            });
                            props?.onChange({
                                target: {
                                    name: props?.name,
                                    value: newValue
                                }
                            });
                            setValue(newValue)
                        }
                    }}
                />
            ) : (
                <Input
                    {...props} />
            )}
        </>
    );
};

export { InputNumber };
const CustomColorPicker = ({
    modal = true,
    //請先用做基本的如果沒有動作，那就是沒有功能 ＱＱ
    allowClear = false,
    arrow = { pointAtCenter: true },
    children,
    defaultValue = "#000",
    defaultFormat = "hex",
    disabled = false,
    // disabledAlpha = false,
    // destroyTooltipOnHide = false,
    format = "hex", //目前還沒辦法轉換
    // mode = ["single"], 目前沒有
    open,
    presets = [],
    placement = "bottomLeft",
    panelRender,
    showText = true,
    size = "medium",
    trigger = "click",
    value,
    onChange = () => { },
    onChangeComplete,
    onFormatChange,
    onOpenChange,
    onClear,
    onValueChange = () => { },
    name,
    ...props
}) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;

    const [color, setColor] = useState(value || defaultValue);
    const [isOpen, setIsOpen] = useState(open || false);

    const handleColorChange = (newColor) => {
        setColor(newColor);

        onValueChange({
            target: {
                name: name,
                value: newColor,
            },
        });
        if (onChange) {
            onChange({
                target: {
                    name: name,
                    value: newColor,
                },
            });
        }
    };

    const handleColorChangeComplete = () => {
        if (onChangeComplete) onChangeComplete(color);
    };

    const handleClear = () => {
        setColor("");
        if (onClear) onClear();
    };

    const handleFormatChange = (newFormat) => {
        if (onFormatChange) onFormatChange(newFormat);
    };

    const handleOpenChange = (isOpen) => {
        setIsOpen(isOpen);
        if (onOpenChange) onOpenChange(isOpen);
    };

    const renderColorPicker = (control) => {
        if (control) {
            switch (format) {
                case "rgb":
                    return (
                        <RgbColorPicker
                            color={value}
                            onChange={handleColorChange}
                        />
                    );
                default:
                    return (
                        <HexColorPicker
                            color={value}
                            onChange={handleColorChange}
                        />
                    );
            }
        } else {
            switch (format) {
                case "rgb":
                    return (
                        <RgbColorPicker
                            color={color}
                            onChange={handleColorChange}
                        />
                    );
                default:
                    return (
                        <HexColorPicker
                            color={color}
                            onChange={handleColorChange}
                        />
                    );
            }
        }
    };

    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <Popover
                            modal={true}
                            open={isOpen} onOpenChange={handleOpenChange}>
                            <PopoverTrigger asChild>
                                <Button
                                    type="button"
                                    disabled={disabled}
                                    variant={"outline"}
                                >
                                    <Row gutter={[4, 4]} align={"middle"}>
                                        <Col>
                                            <div
                                                style={{
                                                    width: "20vw", // 使用 vw 單位以便在不同寬度的設備上保持響應式
                                                    height: "20vw", // 高度設置為和寬度相同，保持正方形
                                                    maxWidth: "20px", // 設置最大寬度
                                                    maxHeight: "20px", // 設置最大高度
                                                    minWidth: "15px", // 設置最小寬度
                                                    minHeight: "15px", // 設置最小高度
                                                    backgroundColor: value,
                                                    borderRadius: "4px",
                                                }}
                                            ></div>
                                        </Col>
                                        <Col>
                                            {children ||
                                                (showText && value) ||
                                                "選擇顏色"}
                                        </Col>
                                    </Row>
                                </Button>
                            </PopoverTrigger>
                            <PopoverContent
                                className={`z-100 w-64  ${arrow.pointAtCenter ? "arrow-center" : ""
                                    }`}
                                style={{
                                    zIndex: 100
                                }}
                                placement={placement}
                            >
                                <Row gutter={[8, 8]}>
                                    <Col span={24}>
                                        <Row justify={"center"}>
                                            <Col>
                                                {panelRender
                                                    ? panelRender(
                                                        renderColorPicker(),
                                                        {
                                                            components: {
                                                                Picker: renderColorPicker,
                                                            },
                                                        }
                                                    )
                                                    : renderColorPicker()}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <Row justify={"end"}>
                                            <Col>
                                                <Input
                                                    maxlength="7"
                                                    className={"h-8"}
                                                    style={{
                                                        width: "7rem",
                                                    }}
                                                    value={value}
                                                    onChange={(e) => {
                                                        onValueChange({
                                                            target: {
                                                                ...e.target,
                                                                value: e.target
                                                                    .value,
                                                            },
                                                        });
                                                        setColor(
                                                            e.target.value
                                                        );
                                                    }}
                                                ></Input>
                                            </Col>
                                            <Col>
                                                {allowClear && (
                                                    <Button
                                                        size="small"
                                                        onClick={handleClear}
                                                        variant="secondary"
                                                    >
                                                        清除
                                                    </Button>
                                                )}
                                            </Col>
                                            <Col>
                                                <Button
                                                    variant={"ghost"}
                                                    size={"small"}
                                                    onClick={
                                                        handleColorChangeComplete
                                                    }
                                                >
                                                    {trigger === "click"
                                                        ? "確認"
                                                        : "關閉"}
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col span={24}>
                                        <div className="mt-4 flex justify-between"></div>
                                        {presets.length > 0 && (
                                            <div className="mt-4">
                                                {presets.map(
                                                    (preset, index) => (
                                                        <div key={index}>
                                                            <p>
                                                                {preset.label}
                                                            </p>
                                                            <div className="flex space-x-2">
                                                                {preset?.colors.map(
                                                                    (
                                                                        presetColor,
                                                                        i
                                                                    ) => (
                                                                        <div
                                                                            key={
                                                                                i
                                                                            }
                                                                            className="w-6 h-6"
                                                                            style={{
                                                                                backgroundColor:
                                                                                    presetColor,
                                                                            }}
                                                                            onClick={() =>
                                                                                handleColorChange(
                                                                                    presetColor
                                                                                )
                                                                            }
                                                                        />
                                                                    )
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        )}
                                    </Col>
                                </Row>

                                {/* <div className="mt-2 flex space-x-2">
                            <Button
                                size={"small"}
                                variant="outline"
                                onClick={() => handleFormatChange("hex")}
                            >
                                HEX
                            </Button>
                            <Button
                                size={"small"}
                                variant="outline"
                                onClick={() => handleFormatChange("rgb")}
                            >
                                RGB
                            </Button>
                        </div> */}
                            </PopoverContent>
                        </Popover>
                    )}
                />
            ) : (
                <Popover
                    modal={true}
                    open={isOpen} onOpenChange={handleOpenChange}>
                    <PopoverTrigger asChild>
                        <Button
                            type="button"
                            size={size}
                            disabled={disabled}
                            variant={"outline"}
                        >
                            <Row gutter={[4, 4]} align={"middle"}>
                                <Col>
                                    <div
                                        style={{
                                            width: "20vw", // 使用 vw 單位以便在不同寬度的設備上保持響應式
                                            height: "20vw", // 高度設置為和寬度相同，保持正方形
                                            maxWidth: "20px", // 設置最大寬度
                                            maxHeight: "20px", // 設置最大高度
                                            minWidth: "15px", // 設置最小寬度
                                            minHeight: "15px", // 設置最小高度
                                            backgroundColor: color,
                                            borderRadius: "4px",
                                        }}
                                    ></div>
                                </Col>
                                <Col>
                                    {children ||
                                        (showText && color) ||
                                        "選擇顏色"}
                                </Col>
                            </Row>
                        </Button>
                    </PopoverTrigger>
                    <PopoverContent
                        className={`w-64  ${arrow.pointAtCenter ? "arrow-center" : ""
                            }`}
                        placement={placement}
                    >
                        <Row gutter={[8, 8]}>
                            <Col span={24}>
                                <Row justify={"center"}>
                                    <Col>
                                        {panelRender
                                            ? panelRender(renderColorPicker(), {
                                                components: {
                                                    Picker: renderColorPicker,
                                                },
                                            })
                                            : renderColorPicker()}
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <Row justify={"end"}>
                                    <Col>
                                        <Input
                                            maxlength="7"
                                            className={"h-8"}
                                            style={{
                                                width: "7rem",
                                            }}
                                            value={color}
                                            onChange={(e) => {
                                                setColor(e.target.value);
                                            }}
                                        ></Input>
                                    </Col>
                                    <Col>
                                        {allowClear && (
                                            <Button
                                                size="small"
                                                onClick={handleClear}
                                                variant="secondary"
                                            >
                                                清除
                                            </Button>
                                        )}
                                    </Col>
                                    <Col>
                                        <Button
                                            variant={"ghost"}
                                            size={"small"}
                                            onClick={handleColorChangeComplete}
                                        >
                                            {trigger === "click"
                                                ? "確認"
                                                : "關閉"}
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={24}>
                                <div className="mt-4 flex justify-between"></div>
                                {presets.length > 0 && (
                                    <div className="mt-4">
                                        {presets.map((preset, index) => (
                                            <div key={index}>
                                                <p>{preset.label}</p>
                                                <div className="flex space-x-2">
                                                    {preset?.colors.map(
                                                        (presetColor, i) => (
                                                            <div
                                                                key={i}
                                                                className="w-6 h-6"
                                                                style={{
                                                                    backgroundColor:
                                                                        presetColor,
                                                                }}
                                                                onClick={() =>
                                                                    handleColorChange(
                                                                        presetColor
                                                                    )
                                                                }
                                                            />
                                                        )
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </Col>
                        </Row>

                        {/* <div className="mt-2 flex space-x-2">
                    <Button
                        size={"small"}
                        variant="outline"
                        onClick={() => handleFormatChange("hex")}
                    >
                        HEX
                    </Button>
                    <Button
                        size={"small"}
                        variant="outline"
                        onClick={() => handleFormatChange("rgb")}
                    >
                        RGB
                    </Button>
                </div> */}
                    </PopoverContent>
                </Popover>
            )}
        </>
    );
};

export { CustomColorPicker as ColorPicker };
const CustomMultipleSelector = ({ name, value, onValueChange, ...props }) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => {
                        //目前 Form 會強行轉成套件關係 set 陣列要先 stringify
                        //這裡會 再parse轉回來
                        let temp = value;
                        if (typeof temp === "string" && temp !== "") {
                            temp = JSON.parse(temp);
                        }
                        return (
                            <MultipleSelector
                                {...props}
                                onChange={(val) => {
                                    onValueChange({
                                        target: {
                                            value: val,
                                        },
                                    });
                                }}
                                value={temp || []}
                            />
                        );
                    }}
                />
            ) : (
                <MultipleSelector {...props} />
            )}
        </>
    );
};
export { CustomMultipleSelector as MultipleSelector };

const jsonToQueryString = (json) => {
    return new URLSearchParams(json).toString();
};
export { jsonToQueryString }

const CustomMultipleSelectorV2 = ({ name, value, onValueChange, options, ...props }) => {
    const formContext = useFormContext();
    const control = formContext ? formContext.control : undefined;
    const values2LabelValues = (values) => {
        let labelValues = (options || []).filter((option) => {
            return values.includes(option?.value)
        })
        return labelValues
    }

    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => {
                        return (
                            <MultipleSelector
                                {...props}
                                options={options}
                                onChange={(selectLabelValues) => {
                                    let selectValues = selectLabelValues.map((selectLabelValue) => selectLabelValue?.value)
                                    onValueChange({
                                        target: {
                                            value: selectValues,
                                        },
                                    });
                                }}
                                value={values2LabelValues(value) || []}
                            />
                        );
                    }}
                />
            ) : (
                <MultipleSelector
                    options={options}
                    {...props}
                    value={values2LabelValues(value)}

                />
            )}
        </>
    );
}
export { CustomMultipleSelectorV2 as MultipleSelectorV2 };


const MainModal = (
    {
        title = null,
        axiosMode = "post",
        propsForm,
        propsOpen = null,
        propsLoading = null,
        propsSetOpen = () => {

        },
        onFinish = () => {

        },
        width,
        formElement = <div></div>,
        keyPrefix,
        contentStyle = {}
    }
) => {
    const { t: tProps } = useTranslation('translation', { keyPrefix: keyPrefix })
    const { t: tDefault } = useTranslation('translation')
    const t = keyPrefix ? tProps : tDefault
    const axiosModelanguage = {
        get: t('get'),
        post: t('post'),
        patch: t('patch'),
        delete: t('delete'),
    }
    const [form] = CustomForm.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }
    const handleGenerate = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        onFinish(values)
    }
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])
    return <>
        {
            propsOpen === null &&
            <CustomButton type="primary" onClick={showModal}>
                {
                    `${axiosModelanguage[axiosMode]}${t('data')}`
                }
            </CustomButton>
        }
        <CustomModal
            style={{ top: 10 }}
            title={title ? title : `${axiosModelanguage[axiosMode]}${t('data')}`}
            open={propsOpen === null ? isModalOpen : propsOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            confirmLoading={propsLoading === null ? loading : propsLoading}
            maskClosable={false}
            contentStyle={{
                padding: 8,
                ...contentStyle,
            }}
            width={width}
            okText={t('submit')}
            cancelText={t('cancel')}
        >
            <Row>
                <Col span={24}>
                    {React.cloneElement(formElement, {
                        formReloadCount: formReloadCount,
                        open: propsOpen === null ? isModalOpen : propsOpen,
                        axiosMode: axiosMode,
                        propsForm: propsForm ? propsForm : form,
                        onFormFinish: onFormFinish,
                    })}
                </Col>
            </Row>
        </CustomModal>
    </>
}
export { MainModal }

const getSpaceAlignItems = (align) => {
    switch (align) {
        case 'start':
            return 'flex-start';
        case 'end':
            return 'flex-end';
        case 'center':
            return 'center';
        case 'baseline':
            return 'baseline';
        default:
            return 'flex-start';
    }
};

const getSpaceDirection = (direction) => {
    return direction === 'vertical' ? 'column' : 'row';
};

const getSpaceGap = (size) => {
    if (Array.isArray(size)) {
        const [horizontal, vertical] = size;
        return `${vertical}px ${horizontal}px`;
    }
    return `${size}px`;
};

const SpaceWrapper = styled.div`
    display: flex;
    flex-direction: ${({ direction }) => getSpaceDirection(direction)};
    flex-wrap: ${({ wrap }) => (wrap ? 'wrap' : 'nowrap')};
    align-items: ${({ align }) => getSpaceAlignItems(align)};
    gap: ${({ size }) => getSpaceGap(size)};
`;

const Space = ({ align = 'start', direction = 'horizontal', size = 'small', wrap = false, children, ...props }) => {
    return (
        <SpaceWrapper align={align} direction={direction} size={size} wrap={wrap} {...props}>
            {children}
        </SpaceWrapper>
    );
};

export { Space };

export { ClassifyStructure }
const ExpandableText = ({
    style,
    text,
    maxLines,
    minHeight = false,
    alwaysShowButton = false, // 新增屬性來控制是否保留按鈕佔位
    expandedStyle = "icon"//顯示使用圖示或文字
}) => {
    const [expanded, setExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef(null);
    const [calculatedMinHeight, setCalculatedMinHeight] = useState('');

    const calculateOverflow = () => {
        if (textRef.current) {
            const totalHeight = textRef.current.scrollHeight;
            const lineHeight = parseFloat(window.getComputedStyle(textRef.current).lineHeight);
            const visibleHeight = lineHeight * maxLines;

            // 設置 minHeight 為動態計算出的行高
            if (minHeight) {
                setCalculatedMinHeight(`${lineHeight * maxLines}px`);
            }

            setIsOverflowing(totalHeight > visibleHeight);
        }
    };

    useEffect(() => {
        calculateOverflow(); // 初次渲染時計算是否超過行數

        const handleResize = () => {
            calculateOverflow(); // 畫面變動時重新計算
        };

        window.addEventListener('resize', handleResize); // 監聽窗口變動

        return () => {
            window.removeEventListener('resize', handleResize); // 清理事件監聽器
        };
    }, [text, maxLines, minHeight]);

    const toggleExpand = () => {
        setExpanded(!expanded);
    };

    const textStyle = {
        display: '-webkit-box',
        WebkitLineClamp: expanded ? 'unset' : maxLines,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: '1.5', // 假設默認行高為1.5em，可以根據實際樣式調整
        whiteSpace: 'pre-wrap', // 確保文本中的 \n 能夠換行

    };

    return (
        <Row>
            <Col
                span={24}
                style={{
                    minHeight: minHeight ? calculatedMinHeight : '' // 動態設置最小高度
                }}
            >
                <p ref={textRef} style={{ ...textStyle, ...style }}>{text}</p>
            </Col>
            <Col span={24}>
                {isOverflowing || alwaysShowButton ? (
                    <button
                        onClick={toggleExpand}
                        type="link"
                        style={{
                            visibility: isOverflowing ? 'visible' : 'hidden', // 當文本沒溢出時，隱藏按鈕但保留佔位
                            color: expanded ? "#6EACDA" : "#FB773C"
                        }}
                    >
                        {expanded
                            ?
                            (expandedStyle === "icon" ? <ChevronUp /> : "收起")
                            :
                            (expandedStyle === "icon" ? <ChevronDown /> : "展開")
                        }

                    </button>
                ) : null}
            </Col>
        </Row>
    );
};
export { ExpandableText }
const CustomSkeleton = ({ }) => {
    return <>
        <div className="flex flex-col space-y-3">
            <Skeleton className="h-[125px] w-[80vw] rounded-xl" />
            <div className="space-y-2">
                <Skeleton className="h-4 w-[60vw]" />
                <Skeleton className="h-4 w-[60vw]" />
            </div>
        </div>
    </>
}
export { CustomSkeleton as Skeleton }


const EditorContainer = styled.div`
    &{
        z-index: 99999
    }
    .jodit-popup{
        position: absolute;
        top:0 !important;
        left:0 !important;
    }
    .jodit-dialog__panel{
        position: fixed;
        top:0 !important;
        left:0 !important;
    }
`
const CustomJoditEditor = forwardRef((
    {
        propsHidden = false,
        ...props
    },
    ref
) => {
    const editorContainerRef = useRef(null);
    const popoverRef = useRef(null);
    useEffect(() => {
        const moveJoditPopups = () => {
            if (!!propsHidden) {
                return;
            }
            const joditPopups = document.querySelectorAll('.jodit-popup');
            const joditDialog = document.querySelectorAll('.jodit.jodit-dialog');
            joditPopups.forEach(popup => {
                if (popoverRef.current && !popoverRef.current.contains(popup)) {
                    popoverRef.current.appendChild(popup);
                    const firstInput = popoverRef.current?.querySelector('input');
                    if (firstInput) {
                        firstInput.focus(); // Set focus on the first input
                        popoverRef.current.scrollIntoView()
                    }
                }
            });
            joditDialog.forEach(popup => {
                if (editorContainerRef.current && !editorContainerRef.current.contains(popup)) {
                    editorContainerRef.current.appendChild(popup);
                    const firstInput = editorContainerRef.current?.querySelector('input');
                    if (firstInput) {
                        firstInput.focus(); // Set focus on the first input
                        editorContainerRef.current.scrollIntoView()
                    }
                }
            });
        };

        // Add event listeners if necessary when Jodit generates new elements
        const observer = new MutationObserver(moveJoditPopups);
        observer.observe(document.body, { childList: true, subtree: true });
        return () => observer.disconnect();

    }, [])
    return <EditorContainer
        ref={editorContainerRef}
    >
        <div style={{ position: 'relative', zIndex: 99999 }} ref={popoverRef}
            onMouseDown={(e) => e.stopPropagation()} // Stop clicks from propagating
            onBlur={(e) => e.stopPropagation()}
            onClick={(e) => {
                e.stopPropagation()
            }}
        />
        <JoditEditor
            ref={ref}
            {...props}
        />
    </EditorContainer>
})
export { CustomJoditEditor as JoditEditor }

const isOverlapping = (time, selectableRanges) => {
    const [start, end] = time.split("-").map(t => new Date(`1970-01-01T${t}:00`));

    return selectableRanges.some(range => {
        if (range) {
            const [rangeStart, rangeEnd] = range.split("-").map(t => new Date(`1970-01-01T${t}:00`));
            return (start < rangeEnd && end > rangeStart);
        }
        return false;
    });
};
// 確認時間是否在可選範圍內
const isWithinSelectableRange = (time, selectableRanges) => {
    const [start, end] = time?.split("-").map(t => new Date(`1970-01-01T${t}:00`));
    if (selectableRanges.length > 0) {
        return selectableRanges.some(range => {
            if (range) {
                const [rangeStart, rangeEnd] = range?.split("-").map(t => new Date(`1970-01-01T${t}:00`));
                // console.log(start >= rangeStart, end <= rangeEnd)
                return start >= rangeStart && end <= rangeEnd;
            } else {
                return true && true;
            }
        });
    } else {
        return true && true;
    }
};
const TimeSelector = ({
    initialSelectedTimes = [],    // 已選時間陣列
    initialDisabledTimes = [],    // 不可選時間陣列
    slotInterval = 60,            // 時間槽間隔，預設為 60 分鐘
    maxHours,                  // 最大選擇時數上限
    selectableRanges = ["00:00-23:59"],  // 可選範圍
    customSelectedTimes = [],
    setCustomSelectedTimes = () => { },
    onChange = () => { },
    onValueChange = () => { },
    name,
    value,
}) => {
    const [selectedTimes, setSelectedTimes] = useState(new Set(initialSelectedTimes));
    const [disabledTimes, setDisabledTimes] = useState(new Set(initialDisabledTimes));
    const [isDragging, setIsDragging] = useState(false);
    const formContext = useFormContext();

    const control = formContext ? formContext.control : undefined;

    // 定義樣式
    const selectableStyle = 'bg-green-100 text-green-900 hover:bg-green-200';
    const selectedStyle = 'bg-blue-500 text-white';
    const disabledStyle = 'bg-pink-200 text-gray-500 cursor-not-allowed';


    // 計算時間段
    const hours = Array.from({ length: (24 * 60) / slotInterval }, (_, i) => {
        const start = new Date();
        start.setHours(0, i * slotInterval, 0, 0);
        const end = new Date(start);
        end.setMinutes(59); // 設置結束時間為該小時的59分
        const timeSlot = `${start.toTimeString().slice(0, 5)}-${end.toTimeString().slice(0, 5)}`;
        return {
            time: timeSlot,
            disabled: disabledTimes.has(timeSlot) || !isWithinSelectableRange(timeSlot, selectableRanges),
        };
    });

    // 處理時間選擇
    const handleSlotClick = (hour) => {
        if (hour.disabled) return;

        const updatedTimes = new Set(selectedTimes);
        if (updatedTimes.has(hour.time)) {
            updatedTimes.delete(hour.time);
        } else {
            if (maxHours && (updatedTimes.size + 1) * slotInterval / 60 > maxHours) {
                customMessage.error(`選擇的時間超過上限 ${maxHours} 小時`);
                return;
            } else {
                updatedTimes.add(hour.time);
            }
        }
        onChange(
            {
                target: {
                    name: name,
                    value: [...updatedTimes]
                }
            }
        )
        onValueChange(
            {
                target: {
                    name: name,
                    value: [...updatedTimes]
                }
            }
        )
        setCustomSelectedTimes(updatedTimes);
        setSelectedTimes(updatedTimes);
    };

    const handleMouseDown = (hour) => {
        if (hour.disabled) return;
        setIsDragging(true);
        handleSlotClick(hour);
    };

    const handleMouseOver = (hour) => {
        if (isDragging && !hour.disabled) {
            handleSlotClick(hour);
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
    };

    // 獲取已選時間段並排序
    const getSelectedSlots = () => {
        const sortedTimes = Array.from(selectedTimes).sort((a, b) => {
            const [aStart] = a.split(' - ');
            const [bStart] = b.split(' - ');
            return new Date(`1970-01-01T${aStart}:00`) - new Date(`1970-01-01T${bStart}:00`);
        });

        customMessage.success(`已選擇的時間區段：\n${sortedTimes.join('\n')}`);
    };

    const totalHours = (selectedTimes.size * slotInterval) / 60;

    useEffect(() => {
        setSelectedTimes(new Set(initialSelectedTimes ? initialSelectedTimes?.concat(value || []) : value));
        setDisabledTimes(new Set(initialDisabledTimes));
    }, [initialSelectedTimes, initialDisabledTimes, value]);

    return (
        <>
            {control ? (
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => {
                        return (
                            <div className="p-4">
                                <div
                                    className="grid gap-2"
                                    style={{
                                        gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))',
                                    }}
                                    onMouseUp={handleMouseUp}
                                >
                                    {hours.map((hour, index) => (
                                        <button
                                            key={index}
                                            type="button"  // 防止按鈕觸發表單提交
                                            onMouseDown={() => handleMouseDown(hour)}
                                            onMouseOver={() => handleMouseOver(hour)}
                                            onMouseUp={handleMouseUp}
                                            className={`border p-2 rounded-md text-sm font-medium transition-all duration-300 ${hour.disabled ? disabledStyle : selectedTimes.has(hour.time) ? selectedStyle : selectableStyle
                                                }`}
                                            disabled={hour?.disabled}
                                        >
                                            {hour?.time}
                                        </button>
                                    ))}
                                </div>

                                <Row className="mt-4 text-center">
                                    <Col className="text-lg font-medium" span={24}>
                                        總時數：{totalHours} 小時
                                    </Col>
                                </Row>
                            </div>
                        );
                    }}
                />
            ) : (
                <div className="p-4">
                    <div
                        className="grid gap-2"
                        style={{
                            gridTemplateColumns: 'repeat(auto-fit, minmax(80px, 1fr))',
                        }}
                        onMouseUp={handleMouseUp}
                    >
                        {hours.map((hour, index) => (
                            <button
                                key={index}
                                type="button"  // 防止按鈕觸發表單提交
                                onMouseDown={() => handleMouseDown(hour)}
                                onMouseOver={() => handleMouseOver(hour)}
                                onMouseUp={handleMouseUp}
                                className={`border p-2 rounded-md text-sm font-medium transition-all duration-300 ${hour.disabled ? disabledStyle : selectedTimes.has(hour.time) ? selectedStyle : selectableStyle
                                    }`}
                                disabled={hour?.disabled}
                            >
                                {hour?.time}
                            </button>
                        ))}
                    </div>

                    <Row className="mt-4 text-center">
                        <Col className="text-lg font-medium" span={24}>
                            總時數：{totalHours} 小時
                        </Col>
                    </Row>
                </div>
            )}
        </>

    );
};

export { TimeSelector, isWithinSelectableRange, isOverlapping };
export { DeleteButton, PatchButton, PostButton } from './../utility/componentOt/controllers/ProtableOtController'

const ExpandDiv = ({
    text,
    record
}) => {
    const Typography_P_maxLength = 10;
    const [isExpanded, setIsExpanded] = useState(false);
    const toggleExpanded = () => {
        setIsExpanded(pre => !pre);
    }
    return <>
        <div>
            {isExpanded ? (
                <span>
                    {text} <CustomButton type={'link'} onClick={toggleExpanded} style={{ color: '#F29F58' }}>收起</CustomButton>
                </span>
            ) : (
                <span>
                    {text?.length > Typography_P_maxLength ? (
                        <>
                            {text.slice(0, Typography_P_maxLength)}... <CustomButton type={'link'} onClick={toggleExpanded} style={{ color: 'blue' }}> 展開</CustomButton>
                        </>
                    ) : (
                        text
                    )}
                </span>
            )}
        </div>
    </>
}
export { ExpandDiv };
const HeartOutlined = ({ fontSize = '32px', color = '#000', ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="Layer_1"
        width="32"
        height="32"
        version="1.1"
        viewBox="0 0 128 128"
    >
        <path
            fill="#F44336"
            d="M92 8c15.324 0 27.813 12.375 27.996 27.656a12 12 0 0 0-.109 1.281l-.051 3.172c-2.652 24.742-37.203 60.523-55.84 77.273-18.5-16.617-52.695-52-55.773-76.742l-.109-3.703A12 12 0 0 0 8 35.656C8.188 20.375 20.676 8 36 8c8.422 0 16.352 3.875 21.754 10.625L64 26.43l6.246-7.805C75.648 11.875 83.578 8 92 8m0-8C80.621 0 70.598 5.383 64 13.625 57.402 5.383 47.379 0 36 0 16.117 0 0 16.117 0 36c0 .398.105.773.117 1.172H0C0 74.078 64 128 64 128s64-53.922 64-90.828h-.117c.012-.399.117-.774.117-1.172 0-19.883-16.117-36-36-36"
        ></path>
    </svg>
);
export { HeartOutlined };

const HeartFilled = ({ fontSize = '32px', color = '#000', ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="Layer_1"
        width="32"
        height="32"
        version="1.1"
        viewBox="0 0 66.911 66.911"
    >
        <path
            fill="#E34326"
            d="M66.911 22.831c0-10.563-8.558-19.122-19.118-19.122-5.658 0-10.721 2.473-14.223 6.377l-.113.128c-3.5-3.98-8.618-6.505-14.334-6.505C8.561 3.709.005 12.268 0 22.831c0 5.834 2.629 11.059 6.758 14.565h-.007l27.104 25.806 26.308-25.806h-.012c4.128-3.506 6.76-8.727 6.76-14.565"
        ></path>
    </svg>
);
export { HeartFilled };

const ShareAltOutlined = ({ fontSize = '32px', color = '#000', ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={fontSize}
        height={fontSize}
        viewBox="0 0 32 32"
        {...props}
    >
        <path
            fill={color}
            d="M5 5v22h22V5zm2 2h18v18H7zm13 3a2 2 0 0 0-1.992 2.156L13.32 14.5A2 2 0 0 0 12 14a2 2 0 0 0 0 4 2 2 0 0 0 1.32-.5l4.688 2.344A2 2 0 0 0 20 22a2 2 0 0 0 0-4 2 2 0 0 0-1.32.5l-4.688-2.344a2 2 0 0 0 0-.312L18.68 13.5A2 2 0 0 0 20 14a2 2 0 0 0 0-4"
        ></path>
    </svg>
);
export { ShareAltOutlined };

const ArrowRightOutlined = ({ fontSize = '32px', color = '#000', ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
    >
        <path
            fill="#5C5F62"
            d="m17.707 9.293-5-5a.999.999 0 1 0-1.414 1.414L14.586 9H3a1 1 0 1 0 0 2h11.586l-3.293 3.293a.999.999 0 1 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414"
        ></path>
    </svg>
);
export { ArrowRightOutlined };
const NoPermission = ({
    homePagePath = '/'
}) => {
    const navigate = useNavigate();
    const { t } = useTranslation('translation', { keyPrefix: 'language_utility.no_permission' })

    return (<div className="flex h-screen w-full flex-col items-center justify-center bg-background">
        <div className="mx-auto flex max-w-md flex-col items-center justify-center space-y-6 px-4 py-8 text-center">
            <div className="rounded-full bg-destructive/10 p-4">
                <ShieldAlert className="h-12 w-12 text-destructive" />
            </div>
            <h2 className="text-3xl font-bold tracking-tight">{t('no_access_permission')}</h2>
            <p className="text-muted-foreground">{t('no_access_message')}</p>
            <div className="flex flex-col space-y-3 sm:flex-row sm:space-x-3 sm:space-y-0">
                <Button onClick={() => {
                    navigate(homePagePath)
                }} size="lg">
                    <Home className="mr-2 h-4 w-4" />
                    {t('return_home')}
                </Button>
            </div>
        </div>
    </div>)
}
const LoginRequired = ({
    homePagePath = '/',
    loginPagePath = '/login'
}) => {
    const navigate = useNavigate();
    const { t } = useTranslation('translation', { keyPrefix: 'language_utility.login_required' })

    return (<div className="flex h-screen w-full flex-col items-center justify-center bg-background">
        <div className="mx-auto flex max-w-md flex-col items-center justify-center space-y-6 px-4 py-8 text-center">
            <div className="rounded-full bg-amber-100 p-4">
                <LockKeyhole className="h-12 w-12 text-amber-600" />
            </div>
            <h2 className="text-3xl font-bold tracking-tight">{t('login_required')}</h2>
            {/* <p className="text-muted-foreground">{t('login_message')}</p> */}
            <div className="flex flex-col space-y-3 sm:flex-row sm:space-x-3 sm:space-y-0">
                <Button onClick={() => {
                    navigate(loginPagePath)
                }} size="lg">

                    <LogIn className="mr-2 h-4 w-4" />
                    {t('login')}
                </Button>
                <Button
                    onClick={() => {
                        navigate(homePagePath)
                    }}
                    variant="outline"
                    size="lg">
                    <Home className="mr-2 h-4 w-4" />
                    {t('return_home')}
                </Button>
            </div>
        </div>
    </div>)
}
export { NoPermission, LoginRequired }
export { QRCodeSVG as QRCode } from 'qrcode.react'

const BaseColorPicker = ({
    title = '主題色彩：',
    mode = 'single',
    onModeChange,
    icons = {}, // ✅ 父層傳入 icon 對照表
    labels = {}, // ✅ 父層也可傳 label（可選）
    ...props
}) => {
    const currentIcon = icons[mode] ?? null;
    const currentLabel = labels?.[mode] ?? (mode === "single" ? "單一顏色" : "顏色組合");

    const handleClick = () => {
        const nextMode = mode === "single" ? "group" : "single";
        onModeChange?.(nextMode);
    };

    return (
        <div className="flex items-center gap-4">
            <span className="text-base font-semibold">{title}</span>
            <Button icon={currentIcon} onClick={handleClick} {...props}>
                {currentLabel}
            </Button>
        </div>
    );
}

const InfoBlockLabelText = ({
    badge = false,
    badgeName = "",
    labelContent = "",
}) => {
    return (
        <div className="flex items-center gap-2">
            {badge && <Badge className="bg-amber-100 text-amber-800 hover:bg-amber-200">{badgeName}</Badge>}
            <Row className="text-gray-500">{labelContent}</Row>
        </div>
    )
}
export { InfoBlockLabelText as InfoBlockLabel }

// const MultipleSelect = ({
//     options,
//     selected = [],
//     onChange,
//     placeholder = "選擇項目...",
//     searchPlaceholder = "搜尋...",
//     className,
// }) => {
//     const [open, setOpen] = useState(false)

//     const handleSelect = (optionId) => {
//         const newSelected = selected.includes(optionId) ? selected.filter((value) => value !== optionId) : [...selected, optionId]
//         onChange(newSelected)
//     }
//     const handleRemove = (optionId, event) => {
//         event.stopPropagation()
//         onChange(selected.filter((value) => value !== optionId))
//     }
//     const selectedOptions = options.filter((option) => selected.includes(option.value))

//     return (
//         <Popover open={open} onOpenChange={setOpen}>
//         <PopoverTrigger asChild>
//             <Button
//             variant="outline"
//             role="combobox"
//             aria-expanded={open}
//             className={cn("w-full justify-between min-h-[40px] h-auto", className)}
//             >
//             <div className="flex flex-wrap gap-1 flex-1">
//                 {selected.length === 0 ? (
//                 <span className="text-muted-foreground">{placeholder}</span>
//                 ) : (
//                 selectedOptions.map((option) => (
//                     <Badge
//                     key={option.value}
//                     variant="secondary"
//                     className="text-xs bg-blue-100 text-blue-800 hover:bg-blue-200"
//                     >
//                     {option.label}
//                     <X
//                         className="ml-1 h-3 w-3 cursor-pointer hover:text-red-600"
//                         onClick={(e) => handleRemove(option.value, e)}
//                     />
//                     </Badge>
//                 ))
//                 )}
//             </div>
//             <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
//             </Button>
//         </PopoverTrigger>
//         <PopoverContent className="w-full p-0" align="start">
//             <Command>
//                 <CommandInput placeholder={searchPlaceholder} value="" />
//                 <CommandEmpty>找不到相關項目</CommandEmpty>
//                 {/* <CommandGroup className="max-h-64 overflow-auto"> */}
//                     {options.map((option) => (
//                     <CommandItem
//                         key={option.value}
//                         value={option.label}   // 這裡可以是顯示文字，保證 CommandInput 搜得到
//                         onSelect={() => handleSelect(option.value)}
//                         className="cursor-pointer"
//                     >
//                         <Check
//                         className={cn(
//                             "mr-2 h-4 w-4",
//                             selected.includes(option.value) ? "opacity-100" : "opacity-0"
//                         )}
//                         />
//                         <div className="flex-1">
//                         <div className="font-medium">{option.label}</div>
//                         {option.description && (
//                             <div className="text-xs text-muted-foreground">
//                             {option.description}
//                             </div>
//                         )}
//                         </div>
//                     </CommandItem>
//                     ))}
//                 {/* </CommandGroup> */}
//             </Command>
//         </PopoverContent>
//         </Popover>
//     )
// }
const MultipleSelect = ({
    options = [],
    selected = [],
    onSelectChange = () => { },
    placeholder = "選擇項目...",
    searchPlaceholder = "搜尋...",
    className,
}) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");

    // 將 selected.value 抽出來統一做 includes 比對
    const selectedValues = selected.map((item) => item.value);

    const handleSelect = (optionValue) => {
        const exists = selected.find((item) => item.value === optionValue);

        let newSelected;
        if (exists) {
            newSelected = selected.filter((item) => item.value !== optionValue);
        } else {
            const originalOption = options.find((opt) => opt.value === optionValue);
            const id = originalOption?.id ?? undefined; // 若 option 沒有 id 才 fallback
            newSelected = [...selected, { id, value: optionValue }];
        }
        onSelectChange(newSelected);
    };

    const handleRemove = (optionId, event) => {
        event.stopPropagation();
        onSelectChange(selected.filter((item) => item.value !== optionId));
    };

    const selectedOptions = options.filter((option) => selectedValues.includes(option.value));
    const filteredOptions = options.filter((option) =>
        (option?.label || "")?.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Popover open={open} onOpenChange={setOpen}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className={cn("w-full justify-between min-h-[40px] h-auto", className)}
                >
                    <div className="flex flex-wrap gap-1 flex-1">
                        {selected.length === 0 ? (
                            <div className="text-muted-foreground">{placeholder}</div>
                        ) : (
                            selectedOptions.map((option) => (
                                <Badge
                                    key={option.value}
                                    variant="secondary"
                                    className="text-xs bg-blue-100 text-blue-800 hover:bg-blue-200 flex items-center gap-1"
                                >
                                    {option.label}
                                    <X
                                        className="h-3 w-3 cursor-pointer hover:text-red-600"
                                        onClick={(e) => handleRemove(option.value, e)}
                                    />
                                </Badge>
                            ))
                        )}
                    </div>
                    <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                </Button>
            </PopoverTrigger>

            <PopoverContent className="w-full p-2" align="start">
                <Input
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder={searchPlaceholder}
                    className="w-full px-2 py-1 mb-2 border rounded text-sm"
                />

                <div className="flex flex-col gap-1 max-h-64 overflow-auto">
                    {filteredOptions.length === 0 && (
                        <div className="text-muted-foreground px-2 py-1 text-sm">找不到相關項目</div>
                    )}
                    {filteredOptions.map((option) => (
                        <div
                            key={option.value}
                            className="flex items-start gap-2 cursor-pointer hover:bg-gray-50 rounded px-2 py-1"
                            onClick={() => handleSelect(option.value)}
                        >
                            <Check
                                className={cn(
                                    "mt-[2px] h-4 w-4",
                                    selectedValues.includes(option.value) ? "opacity-100" : "opacity-0"
                                )}
                            />
                            <div className="flex flex-col text-sm">
                                <span className="font-medium">{option.label}</span>
                                {option.description && (
                                    <span className="text-xs text-muted-foreground">{option.description}</span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </PopoverContent>
        </Popover>
    );
};
export { MultipleSelect }
function hexToHsl(hex) {
    hex = hex.replace('#', '');
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    const rPerc = r / 255;
    const gPerc = g / 255;
    const bPerc = b / 255;

    const max = Math.max(rPerc, gPerc, bPerc);
    const min = Math.min(rPerc, gPerc, bPerc);
    let h, s, l;

    l = (max + min) / 2;

    if (max === min) {
        h = s = 0; // achromatic
    } else {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case rPerc:
                h = (gPerc - bPerc) / d + (gPerc < bPerc ? 6 : 0);
                break;
            case gPerc:
                h = (bPerc - rPerc) / d + 2;
                break;
            case bPerc:
                h = (rPerc - gPerc) / d + 4;
                break;
        }
        h *= 60;
    }

    return [Math.round(h), Math.round(s * 100), Math.round(l * 100)];
}

function hslToHex(h, s, l) {
    s /= 100;
    l /= 100;
    const k = n => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = n =>
        Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, 9 - k(n), 1))));
    return `#${f(0).toString(16).padStart(2, '0')}${f(8)
        .toString(16)
        .padStart(2, '0')}${f(4).toString(16).padStart(2, '0')}`;
}

function generateShadesFromHex(baseHex) {
    const [h, sBase, lBase] = hexToHsl(baseHex);

    const lightnessMap = {
        50: 95,
        100: 90,
        200: 80,
        300: 70,
        400: 60,
        500: 50,
        600: 40,
        700: 30,
        800: 20,
        900: 10,
    };

    const saturationMap = {
        50: 100,
        100: 100,
        200: 95,
        300: 90,
        400: 85,
        500: sBase,
        600: sBase,
        700: sBase - 10,
        800: sBase - 15,
        900: sBase - 20,
    };

    const result = {};
    for (const level of Object.keys(lightnessMap)) {
        const l = lightnessMap[level];
        const s = Math.max(40, Math.min(100, saturationMap[level]));
        result[level] = hslToHex(h, s, l);
    }
    result.DEFAULT = result[500];
    return result;
}
export { generateShadesFromHex }

export { SpreadsheetEditor } from './spreadsheet-editor.jsx'

export { DataTable } from './data-table.tsx'
const getClassifyStructureTypeDataLanguage = ({ classify_structure_type_data, language_culture_code = "zh-tw" }) => {
    let dataFirst = classify_structure_type_data?.find((element) => element?.language_culture_code === language_culture_code);
    return dataFirst?.language_culture_value
}
export { getClassifyStructureTypeDataLanguage }
// document_form_data to 5w data
const transformFormColumnDataToFiveWData = (form_form_column_data) => {
    let fiveWDataTemp = []
    form_form_column_data?.forEach((column) => {
        let form_column_five_w_sub_data = column?.form_column_five_w_sub_data || []
        let form_column_five_w_sub_first = form_column_five_w_sub_data?.find((_) => true)
        if (!form_column_five_w_sub_first) return
        let existingFiveW = fiveWDataTemp.find(fiveW => fiveW?.five_w_id === form_column_five_w_sub_first?.five_w_id)
        if (existingFiveW) {
            // 已存在相同 five_w_id 的物件，將欄位加入 form_column_data 陣列
            existingFiveW?.form_column_data.push({
                ...column,
            })
            return
        }
        // 不存在相同 five_w_id 的物件，新增一個新的物件
        fiveWDataTemp.push({
            title: getClassifyStructureTypeDataLanguage({ classify_structure_type_data: form_column_five_w_sub_first?.five_w_classify_structure_type_data || [] }) || "",
            five_w_id: form_column_five_w_sub_first?.five_w_id,
            five_w_classify_structure_type_data: form_column_five_w_sub_first?.five_w_classify_structure_type_data || [],
            five_w_icon: form_column_five_w_sub_first?.five_w_icon || "",
            form_column_data: [
                { ...column }
            ],
        })
    })
    // 按照 事、人、時、地、物 排序
    const order = ["事", "人", "時", "地", "物"];
    fiveWDataTemp.sort((a, b) => {
        const aIdx = order.indexOf(a.title);
        const bIdx = order.indexOf(b.title);
        // 未知類型排最後
        return (aIdx === -1 ? 99 : aIdx) - (bIdx === -1 ? 99 : bIdx);
    });

    return fiveWDataTemp;
}
export { transformFormColumnDataToFiveWData }
const transformFiveWDataToFormColumnData = (fiveWData = []) => {
    // fiveWData: [{ title, five_w_id, five_w_classify_structure_type_data, five_w_icon, form_column_data: [...] }, ...]
    // 轉回 form_form_column_data: [column, column, ...]
    let form_form_column_data = [];
    fiveWData.forEach(fiveW => {
        if (Array.isArray(fiveW.form_column_data)) {
            fiveW.form_column_data.forEach(column => {

                form_form_column_data.push({
                    "form_column_form_value_data": [
                        {
                            ...column?.form_column_form_value_data?.[0],
                            code: column?.code,
                        }
                    ],
                    ...column
                });
            });
        }
    });
    return form_form_column_data;
};

export { transformFiveWDataToFormColumnData }
// 建議放在 ot.jsx 或 utils 檔案
function transformFormColumnDataToResponseFormValueData(form_column_data = [], needValue = true) {
    // 只處理有 value 欄位的欄位
    return form_column_data
        // 如果 needValue ＝true 確保 col.value.value 存在且不為 undefined，這樣才能正確處理選項型別的欄位
        .filter(col => {
            if (needValue) {
                return col?.value?.value !== undefined
            }
            else {
                return true
            }
        })
        .map(col => {
            // 判斷 value_type
            let value_type = "";
            if (Array.isArray(col?.form_column_component_definitions_data) && col?.form_column_component_definitions_data.length > 0) {
                value_type = col?.form_column_component_definitions_data[0].component_type;
            }
            // 判斷 is_option
            let is_option = 0;
            if (["dropdown", "multi_select_list", "checkbox"].includes(value_type)) {
                is_option = 1;
            }
            // 處理單選/多選
            let value = col?.value?.value;
            if (is_option && Array.isArray(value)) {
                value = { value: value }; // 多選
            } else if (is_option && typeof value === "number") {
                value = { value: value }; // 單選
            } else if (typeof value === "object" && value !== null && value.value !== undefined) {
                value = value; // 已經包好
            } else {
                value = { value: value }; // 其他型別
            }
            return {
                form_column_form_value_data: [
                    {
                        form_column_id: col?.form_column_id,
                        code: col?.code,
                        is_required: col?.is_required,
                        default_value: col?.default_value,
                        placeholder: col?.placeholder,
                        help_text: col?.help_text,
                        ...col
                        // ...你可依需求補充其他欄位
                    }
                ],
                code: col?.code,
                is_option,
                index: col?.index ?? null,
                value,
                value_type,
            };
        });
}

export { transformFormColumnDataToResponseFormValueData };
// 根據 code 對應填值
function fillCanvasElementWithResponse(canvasElement, response_form_value_data) {
    if (!Array.isArray(canvasElement) || !Array.isArray(response_form_value_data)) return canvasElement;
    // 建立 code->value, code->form_value_id 對應表
    const codeValueMap = {};
    const codeFormValueIdMap = {};
    response_form_value_data.forEach((item) => {
        const code = item?.form_column_form_value_data?.[0]?.code;
        if (code) {
            codeValueMap[code] = item.value?.value;
            codeFormValueIdMap[code] = item.form_value_id;
        }
    });
    // 填入 content 與 form_value_id
    return canvasElement.map((page) => {
        if (!page.elements) return page;
        return {
            ...page,
            elements: page.elements.map((el) => {
                const code = el?.form_form_column_data?.[0]?.code;
                if (code && (codeValueMap.hasOwnProperty(code) || codeFormValueIdMap.hasOwnProperty(code))) {
                    // 填入 content
                    let newEl = { ...el };
                    if (codeValueMap.hasOwnProperty(code)) {
                        newEl.content = codeValueMap[code];
                    }
                    // 填入 form_value_id 到 form_form_column_data[0]
                    if (Array.isArray(newEl.form_form_column_data) && newEl.form_form_column_data.length > 0 && codeFormValueIdMap.hasOwnProperty(code)) {
                        newEl.form_form_column_data = [
                            {
                                ...newEl.form_form_column_data[0],
                                form_value_id: codeFormValueIdMap[code]
                            }
                        ];
                    }
                    return newEl;
                }
                return el;
            })
        };
    });
}
export { fillCanvasElementWithResponse }
const getValueByCode = ({ code, response_form_value_data, onlyValue = false }) => {
    if (!Array.isArray(response_form_value_data)) return undefined;

    for (const item of response_form_value_data) {
        if (!Array.isArray(item.form_column_form_value_data)) continue;

        for (const col of item.form_column_form_value_data) {
            if (col.code !== code) continue;

            if (!onlyValue) {
                // if it's an option (dropdown/radio/checkbox), try to resolve a display label
                if (Number(item?.is_option) === 1) {
                    const selectionOptions = col?.form_column_selection_option_data || col?.form_column_selection_option_data || [];

                    const resolveSingle = (v) => {
                        // 1) try match extra_data entries by explicit value or form_value_id
                        if (Array.isArray(item.extra_data) && item.extra_data.length > 0) {
                            // try find exact match by extra.value.value === v or extra.form_value_id === v
                            const matchExtraExact = item.extra_data.find(ex => (ex?.value?.value !== undefined && String(ex.value.value) === String(v)) || (ex?.form_value_id !== undefined && String(ex.form_value_id) === String(v)));
                            if (matchExtraExact) return matchExtraExact.value?.value;

                            // find extra entry whose form column code contains '名稱'
                            const nameExtra = item.extra_data.find(ex => {
                                const formCols2 = ex.form_column_form_value_data2 || ex.form_column_form_value_data || [];
                                return Array.isArray(formCols2) && formCols2.some(f => typeof f.code === 'string' && f.code.includes('名稱')) && ex?.value?.value !== undefined;
                            });
                            if (nameExtra) return nameExtra.value?.value;

                            // fallback: first extra with any non-empty value
                            const firstExtraWithValue = item.extra_data.find(e => e?.value && e.value.value !== undefined && e.value.value !== null && e.value.value !== '');
                            if (firstExtraWithValue) return firstExtraWithValue.value.value;
                        }

                        // 2) try selection options mapping
                        if (Array.isArray(selectionOptions) && selectionOptions.length > 0) {
                            for (const opt of selectionOptions) {
                                if (opt == null) continue;
                                if (opt.selection_option_id != null && String(opt.selection_option_id) === String(v)) {
                                    return opt.label || opt.name || (opt.selection_option_classify_structure_type_data && opt.selection_option_classify_structure_type_data[0]?.name_language_data?.find(l => l.language_culture_code === 'zh-tw')?.language_culture_value) || v;
                                }
                                if (opt.value != null && String(opt.value) === String(v)) {
                                    return opt.label || opt.name || v;
                                }
                            }
                        }

                        // default fallback: return raw value
                        return v;
                    };
                    const rawVal = item?.value?.value;
                    if (Array.isArray(rawVal)) {
                        let temp = rawVal.map(v => resolveSingle(v));
                        return temp;
                        // return rawVal.map(v => resolveSingle(v));


                    }
                    return resolveSingle(rawVal);
                }
            }

            // default: just return raw value
            return item.value?.value;
        }
    }
    return undefined;
}
export { getValueByCode }

// 轉換畫布元件為回應格式
const transformCanvasElementToResponse = (canvasElement, opts = {}) => {
    // opts may contain: type, response_id (externalResponseId) and any extra fields
    // Only include fields in the output when their value is not null/undefined.
    const { type = "1", response_id: externalResponseId = null, ...extraFields } = opts || {};
    if (!Array.isArray(canvasElement)) return [];

    const optionTypes = ["dropdown", "radio_button", "multi_select_list", "checkbox"];

    // Map by response_id (fallback to generated key when none)
    const map = new Map();

    canvasElement.forEach((page) => {
        (page?.elements || []).forEach((element) => {
            const formFormData = element?.form_form_column_data || [];
            if (!Array.isArray(formFormData) || formFormData.length === 0) return;

            // try to detect a response_id from form_column_source_data -> document_response_data
            let targetResponseId = null;
            for (const ff of formFormData) {
                const sources = ff?.form_column_source_data || [];
                for (const s of sources) {
                    const docResp = s?.document_response_data || [];
                    if (Array.isArray(docResp) && docResp.length > 0 && docResp[0]?.response_id) {
                        targetResponseId = docResp[0].response_id;
                        break;
                    }
                }
                if (targetResponseId) break;
            }

            const responseIdKey = targetResponseId ?? externalResponseId ?? `__no_response_${element?.id ?? Math.random()}`;

            // Build base fields to include in the response object - only include non-null values
            const actualResponseId = targetResponseId ?? externalResponseId ?? null;
            const includeIfNotNull = (obj) => {
                const res = {};
                Object.keys(obj || {}).forEach((k) => {
                    const v = obj[k];
                    if (v !== null && v !== undefined) res[k] = v;
                });
                return res;
            };

            const baseFields = {
                type,
                ...(actualResponseId != null ? { response_id: actualResponseId } : {}),
                ...includeIfNotNull(extraFields),
            };

            const responseObj = map.get(responseIdKey) || { ...baseFields, response_form_value_data: [] };

            // build response_form_value_data entries from formFormData
            formFormData.forEach((ff) => {
                // use element.type as value_type first, fall back to any component def
                const value_type = element?.type || (ff?.form_column_component_definition_data || [])?.[0]?.component_type || "text-content";
                const isOption = optionTypes.includes(value_type) ? 1 : 0;

                // element.content is typically the current value for this element (could be scalar or array)
                const valuePayload = (() => {
                    // preserve original shape if it's already an object with {value:...}
                    if (ff?.value && typeof ff.value === 'object' && 'value' in ff) return ff.value;
                    if (element?.content !== undefined) return { value: element.content };
                    // fallback to ff.default_value or null
                    return { value: ff?.default_value ?? null };
                })();

                const entry = {
                    // include existing ids if present so patch can use them
                    ...(ff?.response_form_value_id ? { response_form_value_id: ff.response_form_value_id } : {}),
                    index: ff?.index ?? null,
                    value: valuePayload,
                    value_type,
                    is_option: isOption,
                    form_column_form_value_data: [
                        {
                            code: ff?.code,
                            form_column_id: ff?.form_column_id
                        }
                    ]
                };

                responseObj.response_form_value_data.push(entry);
            });

            map.set(responseIdKey, responseObj);
        });
    });

    // convert map to array
    return Array.from(map.values()).map(r => ({ ...r }));
};
export { transformCanvasElementToResponse }

const convertResponsesToFormColumnMap = (responses, propsFormColumnData) => {
    return responses.map(response => {
        const result = {};
        (response?.response_form_value_data || []).forEach(item => {
            const formColumnData = Array.isArray(item?.form_column_form_value_data)
                ? item.form_column_form_value_data.find(d => d && d.form_column_id !== undefined)
                : undefined;
            if (formColumnData && formColumnData.form_column_id !== undefined) {
                const columnId = formColumnData.form_column_id;
                const value = item.value?.value;
                const options = (propsFormColumnData?.find(_ => true)?.document_x_canvas_content_data?.find(_ => true)?.content?.find(_ => true)?.elements?.find(item => item?.form_column_id === columnId)?.form_form_column_data?.find(_ => true)?.form_column_selection_option_data || formColumnData.form_column_selection_option_data || []).map(opt => ({
                    selection_option_id: String(opt.selection_option_id),
                    label: opt.selection_option_classify_structure_type_data?.[0]?.name_language_data?.[0]?.language_culture_value || ""
                }));
                const type = item.value_type || formColumnData.form_column_component_definition_data?.[0]?.component_type;

                // 多選
                if (["checkbox", "multi_select_list"].includes(type)) {
                    if (Array.isArray(value)) {
                        result[columnId] = value.map(v => {
                            const found = options.find(opt => String(opt.selection_option_id) === String(v));
                            return found ? found.label : v;
                        }).join("、") || "未填寫";
                    } else {
                        result[columnId] = "未填寫";
                    }
                }
                // 單選
                else if (["selection", "dropdown", "radio_button"].includes(type)) {
                    const found = options.find(opt => String(opt.selection_option_id) === String(value));
                    result[columnId] = found ? found.label : value || "未填寫";
                }
                // 其他型態
                else {
                    result[columnId] = value || "未填寫";
                }
                result[formColumnData.code] = result[columnId]; // 同時以 code 作為 key
            }

        });

        return result;
    });
}
export { convertResponsesToFormColumnMap }


function convertCanvasToResponseData(pages, documentId = 1, type = 1) {
    // 預設只處理第一頁
    const page = Array.isArray(pages) ? pages[0] : pages;
    const response_form_value_data = [];

    (page.elements || []).forEach((element, idx) => {
        // 只處理有 form_column_id 的元件
        if (!element.form_column_id) return;

        // 判斷是否選項型元件
        const isOption = ["dropdown", "radio_button", "multi_select_list", "checkbox"].includes(element.type) ? 1 : 0;

        // value_type
        let value_type = element?.type;
        // value 格式
        let valueObj;
        if (isOption) {
            // 多選用 array，單選用 id
            if (Array.isArray(element.content)) {
                valueObj = { value: element.content.map(v => Number(v)) };
            } else {
                valueObj = { value: Number(element.content) };
            }
        } else {
            valueObj = { value: element.content };
        }

        let base = {
            form_column_form_value_data: [
                {
                    form_column_id: element.form_column_id,
                    code: element?.form_form_column_data?.[0]?.code
                }
            ],
            is_option: isOption,
            index: idx + 1,
            value: valueObj,
            value_type
        };
        response_form_value_data.push(base);
    });
    return [
        {
            type,
            document_response_data: [
                {
                    document_id: documentId
                }
            ],
            response_form_value_data
        }
    ];
}
export { convertCanvasToResponseData }

/**
 * Convert canvas pages (pages with elements) into detailed response payloads.
 * Produces an array of response objects similar to:
 * [ { type: 1, response_id: 5, document_response_data: [{document_id:123}], response_form_value_data: [ ... ] } ]
 *
 * opts:
 *  - type (default 1)
 *  - response_id (optional)
 *  - document_response_data (optional array)
 *
 */
function convertCanvasToDetailedResponses(pages = [], opts = {}) {
    const { type = 1, response_id = null, document_response_data = null } = opts || {};
    if (!Array.isArray(pages)) return [];

    const optionTypes = ["dropdown", "radio_button", "multi_select_list", "checkbox", "selection"];

    const response_form_value_data = [];

    pages.forEach((page) => {
        (page?.elements || []).forEach((element, idx) => {
            // determine value payload
            let valuePayload = null;
            if (element?.content === undefined || element?.content === null) {
                valuePayload = { value: null };
            } else if (typeof element.content === 'object' && 'value' in element.content) {
                valuePayload = element.content;
            } else {
                valuePayload = { value: element.content };
            }

            // determine value_type
            let value_type = element?.type || element?.form_form_column_data?.[0]?.form_column_component_definition_data?.[0]?.component_type || 'text-content';

            const isOption = optionTypes.includes(value_type) ? 1 : 0;

            // build form_column_form_value_data entry using available ids
            const fcfvd = [];
            const form_column_id = element?.form_column_id ?? element?.form_form_column_data?.[0]?.form_column_id;
            const form_column_form_value_id = element?.form_form_column_id ?? element?.form_form_column_data?.[0]?.form_form_column_id;
            const fEntry = {};
            if (form_column_form_value_id != null) fEntry.form_column_form_value_id = form_column_form_value_id;
            if (form_column_id != null) fEntry.form_column_id = form_column_id;
            if (Object.keys(fEntry).length > 0) fcfvd.push(fEntry);

            // index: try element.index or fallback to position
            const index = element?.index ?? null;

            const base = {
                ...(element?.response_form_value_id != null ? { response_form_value_id: element.response_form_value_id } : {}),
                ...(element?.form_value_id != null ? { form_value_id: element.form_value_id } : {}),
                index,
                value: valuePayload,
                value_type,
                is_option: isOption,
                form_column_form_value_data: fcfvd,
            };

            response_form_value_data.push(base);
        });
    });

    const respObj = {
        type,
        ...(response_id != null ? { response_id } : {}),
        ...(Array.isArray(document_response_data) && document_response_data.length ? { document_response_data } : {}),
        response_form_value_data,
    };

    return [respObj];
}
export { convertCanvasToDetailedResponses }

/**
 * 從 document 結構中抽取所有會用到的 document_id（包含 nested document_source_data）
 * 支援的輸入：整個 document 類物件（例如 API 回傳的 dataFirst）
 */
function extractDocumentIdsFromDocumentData(documentData = {}) {
    const ids = new Set();
    try {
        const docClassifyArr = documentData?.document_classify_structure_type_data || [];
        docClassifyArr.forEach(dcs => {
            // canvas content
            const docCanvasArr = dcs?.document_x_canvas_content_data || [];
            docCanvasArr.forEach(dc => {
                const pages = dc?.content || [];
                pages.forEach(page => {
                    (page?.elements || []).forEach(el => {
                        const ffList = el?.form_form_column_data || [];
                        ffList.forEach(ff => {
                            const sources = ff?.form_column_source_data || [];
                            sources.forEach(s => {
                                if (!s) return;
                                if (s.document_id) ids.add(s.document_id);
                                const ds = s.document_source_data || s.document_source || [];
                                if (Array.isArray(ds)) {
                                    ds.forEach(dsi => {
                                        if (dsi && dsi.document_id) ids.add(dsi.document_id);
                                    })
                                }
                            })
                        })
                    })
                })
            })

            // form definitions
            const document_form_data = dcs?.document_form_data || [];
            document_form_data.forEach(df => {
                const formCols = df?.form_form_column_data || [];
                formCols.forEach(fc => {
                    const sources = fc?.form_column_source_data || fc?.form_column_source || [];
                    sources.forEach(s => {
                        if (!s) return;
                        if (s.document_id) ids.add(s.document_id);
                        const ds = s.document_source_data || s.document_source || [];
                        if (Array.isArray(ds)) {
                            ds.forEach(dsi => {
                                if (dsi && dsi.document_id) ids.add(dsi.document_id);
                            })
                        }
                    })
                })
            })
        })
    } catch (e) {
        // ignore
    }
    return Array.from(ids).filter(Boolean);
}

export { extractDocumentIdsFromDocumentData }

/**
 * 根據 code 修改 value.value
 * @param {Array} data 原始資料陣列
 * @param {string} key 要比對的 code 名稱，例如 "空間"
 * @param {*} newValue 要修改成的新值，例如 123
 * @returns {Array} 回傳修改後的新陣列（不改動原資料）
 */
function updateValueByCode(data, key, newValue) {
    return data.map(item => {
        const hasTarget = item.form_column_form_value_data?.some(
            d => d.code === key
        );

        if (hasTarget) {
            return {
                ...item,
                value: {
                    ...item.value,
                    value: newValue
                }
            };
        }

        return item;
    });
}
//拿大表單資訊
const getBigFormDocumentId = (document_value, code = "綁定表單") => {
    let document_classify_structure_type_data = document_value?.document_classify_structure_type_data || []
    let document_classify_structure_type_data_first = document_classify_structure_type_data?.[0]
    let document_form_data = document_classify_structure_type_data_first?.document_form_data || []
    let document_form_data_first = document_form_data?.[0]
    let form_form_column_data = document_form_data_first?.form_form_column_data || []
    let bigFormColumn = form_form_column_data.find(item => item?.code === code)
    let form_column_source_data = bigFormColumn?.form_column_source_data || []
    let form_column_source_data_first = form_column_source_data?.[0]
    let document_source_data = form_column_source_data_first?.document_source_data || []
    let document_source_data_first = document_source_data?.[0]
    let bigFormDocumentId = document_source_data_first?.document_id || null
    return bigFormDocumentId
}


/**
 * 將 responses 轉成表格資料：
 * - 欄位鍵為每個欄位的 code
 * - 值為 getValueByCode 的 raw 值 (item.value.value)
 *
 * @param {Array} responses API 回傳的陣列
 * @param {Object} opts
 * @param {Array<string>=} opts.columns 指定一致的欄位 codes（不提供時，逐筆以實際出現的 codes 為準）
 * @param {boolean=} opts.includeMeta 是否附加 meta 欄位（如 response_id、document_id）
 * @returns {Array<Object>} rows
 */
function responsesToKeyValueTableData(responses = [], opts = {}, onlyValue = true) {
    const { columns = null, includeMeta = false } = opts;

    if (!Array.isArray(responses)) return [];

    return responses.map((resp) => {
        const row = {};
        const items = Array.isArray(resp?.response_form_value_data)
            ? resp.response_form_value_data
            : [];

        // 取得此筆需要處理的 codes
        const codes = Array.isArray(columns) && columns.length
            ? columns
            : Array.from(
                new Set(
                    items.flatMap((it) =>
                        (it?.form_column_form_value_data || [])
                            .map((c) => c?.code)
                            .filter(Boolean)
                    )
                )
            );

        // 依 code 取 raw 值 (value.value)
        codes.forEach((code) => {
            row[code] = getValueByCode({
                code,
                response_form_value_data: items,
                onlyValue // 只要 raw 值
            });
        });

        if (includeMeta) {
            row.response_id = resp?.response_id;
            row.document_id = resp?.document_id;
            row.create_time = resp?.create_time;
            row.last_edit_time = resp?.last_edit_time;
            row.approve = resp?.approve;
            row.approve_time = resp?.approve_time;
            row.create_user_name = resp?.create_user_name;

            row.reaponseValue = resp;
            row.responseValue = resp;
            row.approve = resp?.approve;
            row.approve_time = resp?.approve_time;
            row.create_user_name = resp?.create_user_name;
            row.response_form_value_data = resp?.response_form_value_data;

        }

        return row;
    });
}
/**
     * 將輸入（字串/陣列/數字）轉成 PostgreSQL 大括號陣列字串，例如 "{3166,3168,3171}"。
     * - 若元素為數字則不加引號
     * - 若元素為其他字串則自動 escape 並以雙引號包起來
     * - null -> NULL
     */
const toPgBracedArray = (input) => {
    const arr = parseMaybeArray(input) || [];
    if (arr.length === 0) return "{}";
    const parts = arr.map(item => {
        if (item === null || item === undefined) return "NULL";
        const s = String(item);
        // 整數或浮點數 (純數字)
        if (/^-?\d+(\.\d+)?$/.test(s)) return s;
        // 其他字串 -> escape backslash & double-quote, 包雙引號
        const escaped = s.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
        return `"${escaped}"`;
    });
    return `{${parts.join(",")}}`;
}
const parseMaybeArray = (val) => {
    if (Array.isArray(val)) return val;
    if (typeof val === "string") {
        const s = val.trim();
        // 嘗試 JSON.parse（最安全）
        try {
            const parsed = JSON.parse(s);
            if (Array.isArray(parsed)) return parsed;
            // 如果是單一數字或物件，包成陣列回傳
            if (parsed != null) return [parsed];
        } catch (e) {
            // not JSON -> fallback below
        }
        // 移除外層中括號，再以逗號切分
        const inner = s.replace(/^\[|\]$/g, "").trim();
        if (inner === "") return [];
        return inner.split(",").map(item => {
            const t = item.trim();
            // 轉 number（整數/浮點）
            if (/^-?\d+$/.test(t)) return Number(t);
            if (/^-?\d*\.\d+$/.test(t)) return Number(t);
            // 移除引號
            return t.replace(/^["']|["']$/g, "");
        });
    }
    // 不是字串或陣列 -> 包成單元素陣列（或空陣列）
    return val == null ? [] : [val];
}
// 最基礎傳入資料下載excel 
const handleLargeDownload = (largeData, fileName) => {
    const worker = new Worker(new URL('./base_excel_worker.jsx', import.meta.url));

    worker.postMessage({ data: largeData, fileName: fileName });

    worker.onmessage = (e) => {
        const { buffer, fileName } = e.data;
        const blob = new Blob([buffer], { type: 'application/octet-stream' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.click();

        URL.revokeObjectURL(url);
        worker.terminate(); // 釋放 Worker 資源
    };
};
const convertCardToListViewData = (cardData = []) => {
    return cardData.map((item, index) => {
        return {
            key: item?.key || index,

            baseListView1_1Props: item?.baseCardView1_1Props,

            baseListView1_2Props: {
                value: item?.baseCardView1_3Props?.value,
            },

            baseListView1_3Props: {
                value: item?.baseCardView1_4Props?.value,
            },

            baseListView1_4Props: {
                stats: item?.baseCardView1_5Props?.stats,
            },

            baseListView1_5Props: item?.baseCardView1_6Props,

            baseListView1_6Props: item?.baseCardView1_7Props,

            baseListView1_7Props: item?.baseCardView1_8Props,

            // 保留原始資料
            ...item,
        };
    });
};
function buildUiTemplates(templates) {
    const map = {}

    templates.forEach(item => {
        const def = item.component_definitions_classify_structure_type_data?.[0]
        if (!def) return

        map[item.component_definitions_id] = {
            type: def.component_type,

            // 👉 預設尺寸（可以依 type 調整）
            width: getDefaultWidth(def.component_type),
            height: getDefaultHeight(def.component_type),

            form_column_needed: def.form_column_needed,
            name: item.name
        }
    })

    return map
}
function getDefaultWidth(type) {
    switch (type) {
        case "button": return 200
        case "qrcode": return 200
        default: return 300
    }
}

function getDefaultHeight(type) {
    switch (type) {
        case "image":
        case "photo":
        case "video":
            return 200
        case "button":
            return 50
        case "location":
            return 80
        default:
            return 60
    }
}
function createComponent(def, ui) {
    return {
        component_definitions_id: def.component_definitions_id,

        id: "",
        type: ui.type,
        content: "",

        x: {},
        y: {},
        xLegacy: 0,
        yLegacy: 0,

        width: ui.width,
        height: ui.height,

        style: {},

        title: "",

        // ✅ 強制一定有欄位（重點）
        form_form_column_data: [
            {
                code: `${ui.name}`,   // 先用名稱，後面會加唯一
                is_required: ui.form_column_needed ? "1" : "0",
                default_value: "",
                placeholder: "",
                help_text: "",

                // ✅ 不可以空（你 API 會炸）
                form_column_validation_data: [
                    {
                        max_text_number: 99,
                        min_text_number: 0,
                        min_value: 0,
                        max_value: 999,
                        disable_special_character: 0,
                        only_allow_chinese: 0,
                        only_allow_english: 0,
                        wrong_message: "",
                        validation_classify_structure_type_data: [],
                        validation_selection_option_data: [],
                        form_column_selection_option_data: []
                    }
                ],

                form_column_selection_option_data: []
            }
        ]
    }
}
function generateComponentsOutput(componentCountMap, templates) {
    const output = []

    const uiTemplates = buildUiTemplates(templates)

    const startX = 40
    const startY = 30
    const gap = 20
    const maxWidth = 1000

    let cursorX = startX
    let cursorY = startY
    let rowMaxHeight = 0

    const findDef = (id) =>
        templates.find(t => t.component_definitions_id == id)

    Object.entries(componentCountMap).forEach(([compId, count]) => {
        const def = findDef(compId)
        const ui = uiTemplates[compId]

        if (!def || !ui) return

        for (let i = 0; i < count; i++) {

            const item = createComponent(def, ui)

            // ✅ 唯一 id
            item.id = `${ui.type}-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`

            // ✅ code 唯一
            if (item.form_form_column_data) {
                item.form_form_column_data = item.form_form_column_data.map((col, idx) => ({
                    ...col,
                    code: `${col.code}_${Date.now()}_${idx}`
                }))
            }

            // ✅ 排版（不重疊）
            if (cursorX + item.width > maxWidth) {
                cursorX = startX
                cursorY += rowMaxHeight + gap
                rowMaxHeight = 0
            }

            item.x = { desktop: cursorX, tablet: cursorX, mobile: cursorX }
            item.y = { desktop: cursorY, tablet: cursorY, mobile: cursorY }
            item.xLegacy = cursorX
            item.yLegacy = cursorY

            cursorX += item.width + gap
            rowMaxHeight = Math.max(rowMaxHeight, item.height)

            output.push(item)
        }
    })

    return output
}
function applyResponsiveLayout(components) {
    const DEVICE = {
        desktop: { width: 1200, cols: 12, gap: 16, padding: 24 },
        tablet:  { width: 800,  cols: 8,  gap: 14, padding: 20 },
        mobile:  { width: 375,  cols: 4,  gap: 10, padding: 12 },
    }

    // 深拷貝
    const result = JSON.parse(JSON.stringify(components))

    Object.entries(DEVICE).forEach(([device, deviceSize]) => {
        const { width: canvasWidth, gap, padding } = deviceSize

        let cursorX      = padding
        let cursorY      = padding
        let rowMaxHeight = 0

        result.forEach(item => {
            // ⭐ width/height 可能是物件或數字，取對應裝置的值
            const resolveVal = (val, dev) => {
                if (val === null || val === undefined) return 0
                if (typeof val === "object") {
                    return Number(val[dev] ?? val.desktop ?? Object.values(val)[0] ?? 0)
                }
                return Number(val)
            }

            const width  = resolveVal(item.rwdWidth  ?? item.width,  device)
            const height = resolveVal(item.rwdHeight ?? item.height, device)

            if (width <= 0 || height <= 0) return

            // 換行
            if (cursorX + width > canvasWidth - padding) {
                cursorX      = padding
                cursorY     += rowMaxHeight + gap
                rowMaxHeight = 0
            }

            // 設定 x / y
            if (!item.x) item.x = {}
            if (!item.y) item.y = {}
            item.x[device] = cursorX
            item.y[device] = cursorY

            // legacy（mobile 為主）
            if (device === "mobile") {
                item.xLegacy = cursorX
                item.yLegacy = cursorY
            }

            // 更新游標
            cursorX      += width + gap
            rowMaxHeight  = Math.max(rowMaxHeight, height)
        })
    })

    return result
}
export { applyResponsiveLayout }
export { generateComponentsOutput }
export { convertCardToListViewData }
export { handleLargeDownload }
export { toPgBracedArray }
export { responsesToKeyValueTableData };
export { updateValueByCode }
export { default as FormStatic5 } from './form_static_5.jsx'
export { default as FormStatic6 } from './form_static_6.jsx'
export { default as DataTypeSelection } from './input/data_type_selection.jsx'
export { default as ImportRecords } from './input/import-records.jsx'
export { default as BaseSummaryBlock } from './base_summary_block.js'
export { getBigFormDocumentId }
export { default as FileUpload } from './input/file-upload.jsx'
export { default as Signature } from './signature.jsx'
export { useFile } from './FileController.js'


// ─────────────────────────────────────────────────────────────────────────────
// 分類匯出 — 各類別透過下方 category index 統一存取
// 同名已存在於上方的自訂包裝元件者（Button、Select、Modal 等）維持原實作，
// 原始 Shadcn 版本請直接從各 primitives/ 路徑或 category index 匯入。
// ─────────────────────────────────────────────────────────────────────────────

// ── Hooks ─────────────────────────────────────────────────────────────────────
export { useAnimatedNumber } from './hooks/use-animated-number'
export { useLoadingState } from './hooks/use-loading-state'
export { useIsMobile } from './hooks/use-mobile'
export { useToast } from './hooks/use-toast'
export { useFieldCalculation } from './hooks/use-field-calculation'

// ── 圖表統計 (charts/) ────────────────────────────────────────────────────────
export { default as AnimatedNumber } from './animated-number'
export { default as BaseChart } from './base_chart'
export { default as BaseStatsCardHeader } from './base_stats_card_header'
export { default as BaseSummaryBlock2 } from './base_summary_block_2'
export { default as BaseSummaryBlock2_1 } from './base_summary_block_2_1'
export { default as BaseSummaryBlock2_2 } from './base_summary_block_2_2'
export { default as BaseSummaryBlock2_3 } from './base_summary_block_2_3'
export { default as BaseSummaryBlock2_3_1 } from './base_summary_block_2_3_1'
export { default as DashboardSummary } from './dashboard_summary'
export { default as DashboardSummary1 } from './dashboard_summary_1'
export { default as SegmentedProgressBar } from './segmented_progress_bar'

// ── 卡片視圖 (card_view/) ─────────────────────────────────────────────────────
export { default as BaseCardView } from './base_card_view'
export { default as BaseCardView1 } from './base_card_view_1'
export { default as BaseCardView1_1 } from './base_card_view_1_1'
export { default as BaseCardView1_2 } from './base_card_view_1_2'
export { default as BaseCardView1_3 } from './base_card_view_1_3'
export { default as BaseCardView1_4 } from './base_card_view_1_4'
export { default as BaseCardView1_5 } from './base_card_view_1_5'
export { default as BaseCardView1_6 } from './base_card_view_1_6'
export { default as BaseCardView1_7 } from './base_card_view_1_7'
export { default as BaseCardView1_8 } from './base_card_view_1_8'
export { default as BasePreviewExam } from './base_preview_exam'
export { default as ComponentPage } from './component_page'

// ── 列表視圖 (list_view/) ─────────────────────────────────────────────────────
export { default as BaseListView } from './base_list_view'
export { default as BaseListView1 } from './base_list_view_1'
export { default as BaseListView1_1 } from './base_list_view_1_1'
export { default as BaseListView1_2 } from './base_list_view_1_2'
export { default as BaseListView1_3 } from './base_list_view_1_3'
export { default as BaseListView1_4 } from './base_list_view_1_4'
export { default as BaseListView1_5 } from './base_list_view_1_5'
export { default as BaseListView1_6 } from './base_list_view_1_6'
export { default as BaseListView1_7 } from './base_list_view_1_7'
export { default as ListItemV2 } from './list_item_v2'
export { default as PaginatedContent, DaynamicFetchDataPaginatedContent } from './paginated_content'

// ── 資訊展示 (info_view/) ─────────────────────────────────────────────────────
export { default as Base5wCard } from './base_5w_card'
export { default as BaseInfoBlock } from './base_info_block'
export { default as BaseInfoBlock1 } from './base_info_block_1'
export { default as BaseInfoBlock2 } from './base_info_block_2'
export { default as BaseInfoFormItems } from './base_info_form_items'
export { default as BaseInfoView } from './base_info_view'
export { default as BaseInfoView1 } from './base_info_view_1'
export { default as BaseInfoView1_1 } from './base_info_view_1_1'
export { default as BaseInfoView2 } from './base_info_view_2'
export { default as BaseInfoView2_1 } from './base_info_view_2_1'
export { default as BaseInfoView3 } from './base_info_view_3'
export { default as BaseInfoView3_1 } from './base_info_view_3_1'
export { default as BaseInfoView4 } from './base_info_view_4'
export { default as BaseInfoView4_1 } from './base_info_view_4_1'
export { default as BaseInfoView4_2 } from './base_info_view_4_2'
export { default as BaseInfoView5 } from './base_info_view_5'
export { default as BaseInfoView5_1 } from './base_info_view_5_1'
export { default as BaseInfoView6 } from './base_info_view_6'
export { default as BaseInfoView6_1 } from './base_info_view_6_1'
export { default as BaseSelectInfoFormItems } from './base_select_info_form_items'

// ── 畫布編輯 (canvas/) ────────────────────────────────────────────────────────
export { default as BaseCanvasEdit1 } from './base_canvas_edit_1'
export { default as BaseCanvasEdit2New } from './base_canvas_edit_2_new'
export { default as BaseCanvasEdit3_1_Form } from './base_canvas_edit_3_1_form'
export { default as SettingToolForm } from './base_canvas_edit_3_1_setting_tool_form'
export * from './base_canvas_element_utils'
export { default as BaseDocumentCreateResponseCanvasEdit } from './base_document_create_response_canvas_edit'
export { default as BaseDocumentResponseCanvasEdit } from './base_document_response_canvas_edit'
export { default as BaseDocumentResponseCanvasEditModal } from './base_document_response_canvas_edit_modal'

// ── 布局導航 (layout/) ────────────────────────────────────────────────────────
export { default as BaseCategoryMenu } from './base_category_menu'
export { default as BaseCategoryMenu1 } from './base_category_menu_1'
export { default as BaseContainerTitle } from './base_container_title'
export { default as BaseContainerTitle1 } from './base_container_title_1'
export { default as BaseLayout } from './base_layout'
export { default as BaseLayout1_1 } from './base_layout1_1'
export { default as BaseLayout1_2 } from './base_layout1_2'
export { default as BaseLayout1_3 } from './base_layout1_3'
export { default as BaseViewModeSwitch } from './base_view_mode_switch'
export { default as BaseViewModeSwitch1 } from './base_view_mode_switch_1'
export { default as MainLayout } from '../utility/Main_layout.js'
export { SettingsToolbar } from './settings_toolbar'

// ── 上傳 (upload/) ────────────────────────────────────────────────────────────
export { default as BaseFileUpload } from './base_file_upload'

// ── 選擇器 (select/) ──────────────────────────────────────────────────────────
export { default as AdvancedSearchForm } from './advanced_search_form'
export { default as AdvancedSearchModal } from './advanced_search_modal'
export { default as BaseSelect } from './base_select'
export { default as ConditionFilterModal } from './condition_filter_modal'
export { default as InsertTreeItemModal } from './insert_tree_item_modal'
export { default as KeywordSearchBox } from './keyword_search_box'
export { default as SearchFilterSection } from './search_filter_section'

// ── Name 業務系列 (name/) ─────────────────────────────────────────────────────
export { default as Name6 } from './name_6'
export { default as Name7, ResponseDisplay } from './name_7'
export { default as Name8 } from './name_8'
export { default as Name9 } from './name_9'
export { default as Name11, responseData2TreeselectData } from './name_11'
export { default as Name12 } from './name_12'
export { default as Name13 } from './name_13'
export { default as Name14 } from './name_14'
export { default as Name15 } from './name_15'
export { default as Name16 } from './name_16'
export { default as Name17 } from './name_17'
export { default as Name18 } from './name_18'
export { default as Name19 } from './name_19'
export { default as Name20 } from './name_20'
export { default as Name21 } from './name_21'
export { default as Name22 } from './name_22'
export { default as Name23 } from './name_23'
export { default as Name24 } from './name_24'
export { default as Name25 } from './name_25'
export { default as Name26 } from './name_26'
export { default as Name27 } from './name_27'
export { default as Name28 } from './name_28'
export { default as Name29 } from './name_29'
export { default as Name30 } from './name_30'
export { default as Name31 } from './name_31'
export { default as Name32 } from './name_32'
export { default as Name33 } from './name_33'
export { default as Name34 } from './name_34'
export { default as Name35 } from './name_35'
export { default as Name36 } from './name_36'
// ── Name Demo 系列 (overview / nav / dependency graph) ────────────────────────
export { default as NameDemoOverview } from './name_demo_overview'
export { default as NameDemoNav, NAME_DEMO_PAGES } from './name_demo_nav'
export { default as NameDemoDependencyGraph } from './name_demo_dependency_graph'

// ── Shadcn 原子元件補充 (primitives/) ─────────────────────────────────────────
export * from './alert-dialog'
export * from './collapsible'
export * from './context-menu'
export * from './drawer'
// export * from './navigation-menu'
export * from './scroll-area'
export { default as Slider } from './slider'
export * from './progress'
export * from './pagination'
export * from './table'
export { ToastProvider, ToastViewport, Toast, ToastTitle, ToastDescription, ToastClose, ToastAction } from './toast'
export * from './sortable'
export { default as StarRating } from './star'
export { Spinner } from './spinner'
export { default as LoadingSkeleton } from './loading-skeleton'
export { ProcessSimulationPage } from './steps'
export { default as VirtualKeyboard } from './virtual_keyboard'
export { LabelProvider, useLabelContext } from './label_context'

// ── 其他功能元件 ──────────────────────────────────────────────────────────────
export { default as BaseBulkActionControl } from './base_bulk_action_control'
export { default as BaseBulkActionControl1 } from './base_bulk_action_control_1'
export { default as BaseColorPicker } from './base_color_picker'
export { default as BaseColorPicker1 } from './base_color_picker_1'
export { default as BaseFontSize } from './base_font_size'
export { default as BaseFontSize1 } from './base_font_size_1'
export { default as BaseCashHistoryModal } from './base_cash_history_modal'
export { default as BaseCashManagementModal } from './base_cash_management_modal'
export { default as BaseCashRealTimeModal } from './base_cash_real_time_modal'
export { default as BaseCashRefundModal } from './base_cash_refund_modal'
export { default as DesignTool } from './design_tool'
export { default as GraphVisualization } from './graph_visualization'
export { default as KnowledgeStructure } from './knowledge_structure'
export { default as PreviewImgModal } from './preview_img_modal'
export { default as RenderDisplayComponent } from './render_display_component'
export { default as RenderFillComponent } from './render_fill_component'
// export { ManualPageContent, UserManual } from './user_manual'
